<template>
  <div>
    <vx-card class="relative">
      <div>
        <vs-row vs-w="12" class="mb-5">
          <vs-col vs-lg="2" vs-sm="2" vs-xs="12">
            <vs-button @click="goBack" color="primary" type="border">Back</vs-button>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="8" vs-xs="12">
            <h3>Request Account & Contactdd- {{ campaignDescription.campaign_name }}</h3>

          </vs-col>
          <vs-col vs-lg="2" vs-sm="2" vs-xs="12">
          </vs-col>



        </vs-row>
      </div>
    </vx-card>
    <vx-card class="vxtable">
      <vs-row vs-w="12" class="mb-5">
        <vs-col vs-lg="4" vs-sm="3" vs-xs="12">

        </vs-col>
        <vs-col vs-lg="4" vs-sm="3" vs-xs="12">

        </vs-col>
        <vs-col vs-lg="4" vs-sm="3" vs-xs="12">

          <span class="font-semibold"> Reason : </span> <span
            v-text="accountDescription.reason_for_account_request"></span>


        </vs-col>





      </vs-row>

      <form data-vv-scope="AddNewAccountForm">

        <vs-row vs-w="12" class="mb-5 pt-5">
          <vs-col vs-lg="10" vs-sm="10" vs-xs="12">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Company Name:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" name="AddNewAccountForm.company_name" v-model="accountDescription.company_name"
                  v-validate="'required'" data-vv-as="Company Name" />
              </div>
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('AddNewAccountForm.company_name')">{{
                errors.first('AddNewAccountForm.company_name') }}</span>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Registered Office Country:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <div :class="{
                  correction_field_input_class:
                    correction_fields_array.includes(
                      'registered_office_country'
                    )
                }">
                  <AccountAutocomplete ref="accountEditRegisteredOfficeCountryRef"
                    :chosen="selected_registered_office_country" class="searchbox" :list="getCountries"
                    :searchOn="'registered_office_country'">
                  </AccountAutocomplete>
                </div>

                <!-- <vs-input
                class="w-full"
                v-model="accountDescription.registered_office_country"
              /> -->
              </div>
              <span v-if="registered_office_country_validation" class="text-danger text-sm mt-2 ml-16">{{
                registered_office_country_validation }}</span>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Company Registration Number:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" name="AddNewAccountForm.company_registration_number"
                  v-model="accountDescription.company_registration_number" v-validate="{
                    required: !this.accountDescription.is_sole_trader
                  }" data-vv-as="Company Registration Number" />
              </div>
              <span class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('AddNewAccountForm.company_registration_number')">{{
                  errors.first('AddNewAccountForm.company_registration_number') }}</span>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Website URLs:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" name="website_url" v-validate="'url:require_protocol'" v-model="accounts.web"
                  data-vv-as="website" />

                <template v-for="website in accountDescription.web">
                  <span class="p-5">
                    <p>
                      {{ website.url }}
                      <vs-icon class="ml-10 removeButton" @click="removeSelectedWeb(website)" color="success"
                        icon="clear"></vs-icon>
                    </p>
                  </span>
                </template>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-button @click="addWebsite()" color="primary" type="filled">Add</vs-button>
                <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('website_url')">{{
                  errors.first('website_url')
                }}</span>
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Social Media Pages:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" name="linkedin" v-model="accounts.linkedin" />

                <template v-for="link in accountDescription.linkedin">
                  <span class="p-5">
                    <p>
                      {{ link.url }}
                      <vs-icon class="ml-10 removeButton" @click="removeSelectedLinkedin(link)" color="success"
                        icon="clear"></vs-icon>
                    </p>
                  </span>
                </template>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-button color="primary" @click="addLinkedin" v-validate="'url:require_protocol'"
                  type="filled">Add</vs-button>
                <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('linkedin')">{{ errors.first('linkedin')
                }}</span>
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Company Status:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" name="AddNewAccountForm.company_status" v-validate="'required'"
                  v-model="accountDescription.status" data-vv-as="Company Status" />
              </div>
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('AddNewAccountForm.company_status')">{{
                errors.first('AddNewAccountForm.company_status')
              }}</span>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Company Category:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" name="company_category" v-model="accountDescription.company_category"
                  data-vv-as="Company Category" />
              </div>
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('company_category')">{{
                errors.first('company_category') }}</span>
            </div>

            <!-- Registered Office -->
            <h5 class="mb-5">Registered Office Address</h5>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 1:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" name="registered_office_address_1"
                  v-model="accountDescription.registered_office_address_1" />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 2:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="accountDescription.registered_office_address_2" />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 3:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="accountDescription.registered_office_address_3" />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>City:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="accountDescription.registered_office_city" />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>County:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="accountDescription.registered_office_county" />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Postcode:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="accountDescription.registered_office_postcode" />
              </div>
            </div>

            <!-- Head Office -->
            <h5 class="mb-5">Head Office Address</h5>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Head Office Address is the Same As the Registered Office
                  Address:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <!-- <input type="checkbox" v-model="headOfficeIsRegisteredOffice"/> -->
                <vs-switch vs-icon-on="check_box" vs-icon-off="block" v-model="headOfficeIsRegisteredOffice">
                  <span slot="on">YES</span>
                  <span slot="off">NO</span>
                </vs-switch>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 1:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="accountDescription.head_office_address_1"
                  name="head_office_address_1" />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 2:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="accountDescription.head_office_address_2" />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 3:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="accountDescription.head_office_address_3" />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>City:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" name="head_office_city" v-model="accountDescription.head_office_city" />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>County:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="accountDescription.head_office_county" />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Postcode:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="accountDescription.head_office_postcode" />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Country:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <div :class="{
                  correction_field_input_class:
                    correction_fields_array.includes('head_office_country')
                }">
                  <AccountAutocomplete ref="accountEditHeadOfficeCountryRef" :chosen="selected_head_office_country"
                    class="searchbox" :list="getCountries" :searchOn="'head_office_country'">
                  </AccountAutocomplete>
                </div>

                <!-- <vs-input
                class="w-full"
                v-model="accountDescription.head_office_country"
              /> -->
              </div>
              <span v-if="head_office_country_validation" class="text-danger text-sm mt-2 ml-16">{{
                head_office_country_validation
              }}</span>
            </div>
            <vs-divider class="m-5" />

            <!-- Site Office -->
            <h5 class="mb-5">Site Office Address</h5>
            <template v-for="(site, index) in accounts.satellite_office">
              <div>
                <vs-divider class="m-5" />
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Address Line 1:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input class="w-full" name="satellite_office_address_1" data-vv-as="Address Line 1"
                      v-model="site.address_1" />
                  </div>
                  <vs-icon class="ml-10 removeButton" @click="removeSelectedSiteAddress(site)" color="success"
                    icon="clear"></vs-icon>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Address Line 2:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input class="w-full" v-model="site.address_2" />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Address Line 3:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input class="w-full" v-model="site.address_3" />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>City:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input class="w-full" v-model="site.city" />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>County:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input class="w-full" v-model="site.county" />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Postcode:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input class="w-full" v-model="site.postcode" />
                  </div>
                </div>


                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Telephone:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full" v-if="site.phone != null">
                    <div v-if="site.phone.length != 0">
                      <template v-for="(site_ph, ph_index) in site.phone">
                        <div :key="ph_index" v-if="site_ph.satellite_office_id == site.id">
                          <div class="vx-row">
                            <div class="vx-col sm:w-1/2 w-full">
                              <v-select name="phone_code" class="phone_code" label="name_with_code"
                                :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                v-model="site_ph.phone_code" />
                            </div>
                            <div class="vx-col sm:w-1/2 w-full">
                              <vs-input @input="
                                site_ph.phone_no = site_ph.phone_no
                                  .replace(/[^0-9.]/g, '')
                                  .replace(/(\..*?)\..*/g, '$1')
                                " class="w-full" v-model="site_ph.phone_no" />
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>

                    <div class="vx-col w-full" v-else>
                      <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full">
                          <v-select name="phone_code" class="phone_code" label="name_with_code"
                            :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="site.phone_code" />
                        </div>
                        <div class="vx-col sm:w-1/2 w-full">
                          <vs-input class="w-full" @input="
                            site.phone_no = site.phone_no
                              .replace(/[^0-9.]/g, '')
                              .replace(/(\..*?)\..*/g, '$1')
                            " v-model="site.phone_no" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="vx-col sm:w-1/3 w-full" v-else>
                    <div class="vx-row">
                      <div class="vx-col sm:w-1/2 w-full">
                        <v-select name="phone_code" class="phone_code" label="name_with_code" :options="all_phone_codes"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="site.phone_code" />
                      </div>
                      <div class="vx-col sm:w-1/2 w-full">
                        <vs-input class="w-full" @input="
                          site.phone_no = site.phone_no
                            .replace(/[^0-9.]/g, '')
                            .replace(/(\..*?)\..*/g, '$1')
                          " v-model="site.phone_no" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <vs-col class="mb-5" vs-offset="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <vs-button color="primary" @click="addSiteOffice()" type="filled">Add Satellite Office</vs-button>
            </vs-col>

            <vs-divider class="m-5" />
            <!-- Telephone -->
            <div class="vx-row">
              <h6 class="p-5">Telephone Number(s)</h6>

              <div class="vx-col sm:w-1/3 w-full">
                <vs-button @click="addPhone()" color="primary" type="filled">Add</vs-button>
              </div>
            </div>



            <template v-for="(w, index) in accountDescription.phone">
              <div class="flex mb-4">
                <div class="w-1/6 bg-grid-color-secondary h-12 mr-5">
                  <v-select :class="{
                    correction_field_input_class:
                      (correction_fields_array.includes(
                        'switchboard_phone_code'
                      ) &&
                        accountDescription.phone[index]['phone_type'] ==
                        'Head Office Switchboard') ||
                      (correction_fields_array.includes('phone_code') &&
                        accountDescription.phone[index]['phone_type'] !=
                        'Head Office Switchboard')
                  }" name="phone_code" class="phone_code" label="name_with_code" :options="all_phone_codes"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="accountDescription.phone[index]['phone_code']" />
                </div>

                <div class="w-1/5 bg-grid-color-secondary h-12 mr-5">
                  <vs-input class="w-full" name="phone" v-model="accountDescription.phone[index]['phone_no']" />
                </div>
                <div class="w-1/5 bg-grid-color-secondary h-12 mr-5">




                  <v-select label="name" :options="accounts.phoneTypes" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="accountDescription.phone[index]['phone_type']" />
                </div>

                <div class="w-1/5 bg-grid-color h-12">
                  <vs-icon class="removeButton" @click="removeSelectedPhone(w)" color="success" icon="clear">
                  </vs-icon>
                </div>
              </div>
            </template>

            <div class="vx-row">
              <h6 class="p-5">Sic Codes(s)</h6>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <AccountAutocomplete :class="{
                  correction_field_input_class:
                    correction_fields_array.includes('sic_code')
                }" ref="SicCodeRefEdit" class="searchbox" :chosen="selected_sic_code" :list="getSicCodes"
                  :searchOn="'sic_codes'"></AccountAutocomplete>
              </div>

              <div class="vx-col sm:w-1/3 w-full">
                <vs-button color="primary" @click="addSicCodes" type="filled">Add</vs-button>
              </div>
            </div>




            <template v-for="sic in accounts.joinedSicAndDescription">

              <p class="m-10">
                {{ sic.name }}
                <vs-icon class="ml-10 removeButton" @click="removeNewSelectedSicCode(sic)" color="success"
                  icon="clear"></vs-icon>
              </p>
            </template>

            <vs-divider class="m-5" />
            <h5 class="mb-5">Other Details</h5>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Registration Jurisdiction:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <div :class="{
                  correction_field_input_class:
                    correction_fields_array.includes(
                      'registration_jurisdiction'
                    )
                }">
                  <AccountAutocomplete ref="EditAccountRegistrationJurisdictionRef"
                    :chosen="selected_registration_jurisdiction" class="searchbox" :list="getCountries"
                    :searchOn="'registration_jurisdiction'">
                  </AccountAutocomplete>
                </div>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Parent Company:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <div>
                  <vs-row vs-w="12" class="mb-5">
                    <vs-col vs-lg="11" vs-sm="12" vs-xs="12">
                      <AccountAutocomplete :class="{
                        correction_field_input_class:
                          correction_fields_array.includes('parent')
                      }" ref="EditAccountParentRef" :list="getParentCompany" :searchOn="'parent'">
                      </AccountAutocomplete>
                    </vs-col>

                    <vs-col vs-lg="1" vs-sm="2" vs-xs="12">
                      <vs-icon @click.stop="getSubsidiaryAccounts()" size="small" icon="check" bg="#efd9d9"
                        style="cursor: pointer; margin-left: 15px"></vs-icon>
                    </vs-col>
                  </vs-row>
                </div>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Vertical:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <div :class="{
                  correction_field_input_class:
                    correction_fields_array.includes('vertical')
                }">
                  <AccountAutocomplete ref="EditAccountVerticalRef" class="searchbox" :chosen="selected_vertical"
                    :list="getVerticals" :searchOn="'vertical'"></AccountAutocomplete>
                </div>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Revenue:</span>

              </div>

              <div class="vx-col sm:w-1/3 w-full">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/2 w-full">
                    <v-select :class="{
                      correction_field_input_class:
                        correction_fields_array.includes('currency_code')
                    }" label="label" :options="currencyCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="accountDescription.currency_code" />
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input :class="{
                      correction_field_input_class:
                        correction_fields_array.includes('revenue')
                    }" type="number" class="w-full" v-model="accountDescription.revenue" />
                  </div>
                </div>
                <span v-if="currency_code_validation" class="text-danger text-sm mt-2 ml-16">{{ currency_code_validation
                }}</span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>No. of Employees:</span>
              </div>
              <div class="vx-col sm:w-1/6 w-full">
                <vs-input type="number" class="w-full" v-model="accountDescription.employees" />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Notes:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-textarea class="w-full" v-model="accountDescription.notes" />
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col sm:w-2/3 w-full ml-auto">
                <vs-button @click="submitAccountForm()" class="mr-3 mb-2">Submit</vs-button>
              </div>
            </div>
          </vs-col>

          <vs-col vs-lg="2" vs-sm="2" vs-xs="12">

            <div class="mb-5">
              <u>
                <h4>Potential Matches</h4>
              </u>
            </div>

            <div>
              <vs-list>
                <template v-for="(match, index) in potential_account_matches">
                  <vs-list-item :key="index">
                    <p class="p-2">{{ match.company_name }}</p>
                    <p class="p-2">{{ match.registered_office_country }}</p>
                    <p class="p-2">
                      {{ match.company_registration_number
                      }}<vs-icon @click.stop="viewPotentialMatchAccountDetails(match)" size="small" icon="info"
                        style="cursor: pointer; margin-left: 15px"></vs-icon>
                    </p>

                    <vs-divider class="m-5" />
                  </vs-list-item>
                </template>
              </vs-list>
            </div>
          </vs-col>
        </vs-row>
      </form>
    </vx-card>

    <template v-if="accountExists">
      <vs-popup fullscreen :title="accountDescription.company_name" :active.sync="popupActive">
        <div class="flex justify-between flex-wrap">
          <vs-button class="mb-4 mr-6" @click="accept()" type="border">Accept</vs-button>
          <vs-button class="mb-4" type="border" @click="reject()" color="primary">Reject</vs-button>
        </div>
        <vs-list>
          <vs-list-header title="Key Company Details" color="success"></vs-list-header>
          <vs-list-item title="Company Name ">
            {{ accountDescription.company_name }}
          </vs-list-item>
          <vs-list-item title="Company Registration Number">
            {{ accountDescription.company_registration_number }}
          </vs-list-item>
          <vs-list-item title="Switchboard">
            <template v-for="(ph, index) in accountDescription.phone">
              <div :key="index">
                <template v-for="(ph_type, index2) in ph.phone_type">
                  <div :key="index2" v-if="
                    ph_type.type == 'Switchboard' && ph_type.phone_id == ph.id
                  ">
                    {{ ph.phone_no }}
                  </div>
                </template>
              </div>
            </template>
          </vs-list-item>
          <vs-list-item title="Site Switchboard">
            <template v-for="(ph, index) in accountDescription.phone">
              <div :key="index">
                <template v-for="(ph_type, index2) in ph.phone_type">
                  <div :key="index2" v-if="
                    ph_type.type == 'Site Switchboard' &&
                    ph_type.phone_id == ph.id
                  ">
                    {{ ph.phone_no }}
                  </div>
                </template>
              </div>
            </template>
          </vs-list-item>
        </vs-list>

        <vs-list>
          <vs-list-header title="Address" color="success"></vs-list-header>
          <vs-list-item title="Head Office Address">
            {{ accountDescription.head_office_address_1 }}
            {{ accountDescription.head_office_address_2 }}
            {{ accountDescription.head_office_address_3 }}
            {{ accountDescription.head_office_city }}
            {{ accountDescription.head_office_postcode }}
            {{ accountDescription.head_office_county }}
            {{ accountDescription.head_office_country }}
          </vs-list-item>
          <vs-list-item title="Registered Office Address">
            {{ accountDescription.registered_office_address_1 }}
            {{ accountDescription.registered_office_address_2 }}
            {{ accountDescription.registered_office_address_3 }}
            {{ accountDescription.registered_office_city }}
            {{ accountDescription.registered_office_postcode }}
            {{ accountDescription.registered_office_county }}
            {{ accountDescription.registered_office_country }}
          </vs-list-item>
          <template v-for="(satellite, index) in accountDescription.satellite_office">
            <vs-list-item :title="'Satellite Office ' + (index + 1)" :key="index">
              <template v-for="(phone, index3) in satellite.phone">
                <div :key="index3" v-if="phone.satellite_office_id == satellite.id">
                  {{ phone.phone_no }}
                </div>
              </template>
              {{ satellite.address_1 }}
              {{ satellite.address_2 }}
              {{ satellite.address_3 }}
              {{ satellite.town }}
              {{ satellite.county }}
              {{ satellite.postcode }}

              <template v-for="(country, index2) in satellite.country">
                <div :key="index2" v-if="country.satellite_office_id == satellite.id">
                  {{ country.name_1 }}
                  {{ country.name_2 }}
                  {{ country.name_3 }}
                </div>
              </template>
            </vs-list-item>
          </template>
        </vs-list>

        <vs-list>
          <vs-list-header title="Websites" color="success"></vs-list-header>
          <template v-for="(web, index) in accountDescription.web">
            <div :key="index">
              {{ web.url }}
            </div>
          </template>
        </vs-list>
        <vs-list>
          <vs-list-header title="LinkedIn" color="success"></vs-list-header>
          <template v-for="(linkedin, index) in accountDescription.linkedin">
            <div :key="index">
              {{ linkedin.url }}
            </div>
          </template>
        </vs-list>
      </vs-popup>
    </template>

    <div class="vx-col w-full mb-base" v-if="showUpdateSatelliteOfficePopup">
      <vs-popup fullscreen id="satelliteOfficePopup" :title="update_account_and_add_to_campaign_heading"
        :active.sync="updateSatelliteOfficePopupActive">
        <form>
          <vx-card>
            <div class="vx-row mb-6">
              <vs-row vs-w="12" class="mb-5" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                <vs-col vs-lg="5" vs-sm="5" vs-xs="12">
                  <div class="text-h5 font-medium mb-4 float-right">
                    <u> Master Database </u>
                  </div>
                </vs-col>

                <vs-col vs-lg="2" vs-sm="2" vs-xs="12">
                  <div class="text-h5 font-medium mb-4 ml-20 float-left"></div>
                </vs-col>

                <vs-col vs-lg="3" vs-sm="3" vs-xs="12">
                  <div class="text-h5 font-medium mb-4 ml-14 float-left">
                    <u> Requested Data </u>
                  </div>
                </vs-col>
                <!-- <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
            <div class="text-h5 font-medium mb-4">Build Data</div>
          </vs-col> -->
              </vs-row>

              <div class="vx-col sm:w-1/5 w-full">
                <span>Company Name:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" name="company_name"
                  v-model="updateSatelliteOfficeAccountDescription.company_name" v-validate="'required'"
                  data-vv-as="Company Name" />
              </div>
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('company_name')">{{
                errors.first('company_name') }}</span>

              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{ accountDescription.company_name }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Company Registration Number:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" name="company_registration_number" v-model="updateSatelliteOfficeAccountDescription.company_registration_number
                  " v-validate="{
                    required:
                      !this.updateSatelliteOfficeAccountDescription
                        .is_sole_trader
                  }" data-vv-as="Company Registration Number" />
              </div>
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('company_registration_number')">{{
                errors.first('company_registration_number') }}</span>

              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{ accountDescription.company_registration_number }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Company Status:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" name="company_status" v-validate="'required'"
                  v-model="updateSatelliteOfficeAccountDescription.status" data-vv-as="Company Status" />
              </div>
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('company_status')">{{
                errors.first('company_status') }}</span>
              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{ accountDescription.status }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Company Category:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" name="company_category" v-model="updateSatelliteOfficeAccountDescription.company_category
                  " data-vv-as="Company Category" />
              </div>
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('company_category')">{{
                errors.first('company_category') }}</span>

              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{ accountDescription.company_category }}
              </div>
            </div>
            <vs-divider class="m-5" />

            <!-- Registered Office -->
            <h5 class="mb-5">Registered Office Address</h5>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 1:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" name="registered_office_address_1" v-model="updateSatelliteOfficeAccountDescription.registered_office_address_1
                  " />
              </div>

              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-switch vs-icon-on="check_box" vs-icon-off="block" v-model="overwriteDataBuildRegisteredOfficeAddressToMasterDB
                    ">
                    <span slot="on">YES</span>
                    <span slot="off">NO</span>
                  </vs-switch>
                </div>

                {{ accountDescription.registered_office_address_1 }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 2:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="updateSatelliteOfficeAccountDescription.registered_office_address_2
                  " />
              </div>
              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{ accountDescription.registered_office_address_2 }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 3:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="updateSatelliteOfficeAccountDescription.registered_office_address_3
                  " />
              </div>
              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{ accountDescription.registered_office_address_3 }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>City:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="updateSatelliteOfficeAccountDescription.registered_office_city
                  " />
              </div>
              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{ accountDescription.registered_office_city }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>County:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="updateSatelliteOfficeAccountDescription.registered_office_county
                  " />
              </div>
              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{ accountDescription.registered_office_county }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Postcode:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="updateSatelliteOfficeAccountDescription.registered_office_postcode
                  " />
              </div>
              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{ accountDescription.registered_office_postcode }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Country:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <AccountAutocomplete ref="SatelliteOfficeaccountEditRegisteredOfficeCountryRef"
                  :chosen="selected_registered_office_country" class="searchbox" :list="getCountries"
                  :searchOn="'registered_office_country'">
                </AccountAutocomplete>

                <!-- <vs-input
                class="w-full"
                v-model="updateSatelliteOfficeAccountDescription.registered_office_country"
              /> -->
              </div>
              <span v-if="registered_office_country_validation" class="text-danger text-sm mt-2 ml-16">{{
                registered_office_country_validation }}</span>

              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{ accountDescription.registered_office_country }}
              </div>
            </div>
            <vs-divider class="m-5" />

            <!-- Head Office -->
            <h5 class="mb-5">Head Office Address</h5>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Head Office Address is the Same As the Registered Office
                  Address:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-switch vs-icon-on="check_box" vs-icon-off="block"
                  v-model="satelliteOfficeheadOfficeIsRegisteredOffice">
                  <span slot="on">YES</span>
                  <span slot="off">NO</span>
                </vs-switch>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 1:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="updateSatelliteOfficeAccountDescription.head_office_address_1
                  " name="head_office_address_1" />
              </div>

              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-switch vs-icon-on="check_box" vs-icon-off="block"
                    v-model="overwriteDataBuildHeadOfficeAddressToMasterDB">
                    <span slot="on">YES</span>
                    <span slot="off">NO</span>
                  </vs-switch>
                </div>

                {{ accountDescription.head_office_address_1 }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 2:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="updateSatelliteOfficeAccountDescription.head_office_address_2
                  " />
              </div>
              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{ accountDescription.head_office_address_2 }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 3:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="updateSatelliteOfficeAccountDescription.head_office_address_3
                  " />
              </div>
              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{ accountDescription.head_office_address_3 }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>City:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" name="head_office_city" v-model="updateSatelliteOfficeAccountDescription.head_office_city
                  " />
              </div>
              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{ accountDescription.head_office_city }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>County:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="updateSatelliteOfficeAccountDescription.head_office_county
                  " />
              </div>
              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{ accountDescription.head_office_county }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Postcode:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="updateSatelliteOfficeAccountDescription.head_office_postcode
                  " />
              </div>

              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{ accountDescription.head_office_postcode }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Country:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <AccountAutocomplete ref="SatelliteOfficeaccountEditHeadOfficeCountryRef"
                  :chosen="selected_head_office_country" class="searchbox" :list="getCountries"
                  :searchOn="'head_office_country'">
                </AccountAutocomplete>

                <!-- <vs-input
                class="w-full"
                v-model="updateSatelliteOfficeAccountDescription.head_office_country"
              /> -->
              </div>
              <span v-if="head_office_country_validation" class="text-danger text-sm mt-2 ml-16">{{
                head_office_country_validation }}</span>

              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{ accountDescription.head_office_country }}
              </div>
            </div>
            <vs-divider class="m-5" />
            <div class="vx-row">
              <h6 class="p-5">Website URLs</h6>
            </div>
            <template v-if="
              updateSatelliteOfficeAccountDescription.web &&
              updateSatelliteOfficeAccountDescription.web.length > 0
            ">
            </template>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <vs-input class="w-full" name="website_url" v-validate="'url:require_protocol'"
                  v-model="SatelliteOfficeaccounts.web" data-vv-as="website" />
              </div>

              <div class="vx-col sm:w-1/3 w-full">
                <vs-button @click="SatelliteOfficeaddWebsite" color="primary" type="filled">Add</vs-button>

                <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('website_url')">{{
                  errors.first('website_url') }}</span>
              </div>

              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{ accountDescription.website }}
              </div>
            </div>

            <template v-for="website in updateSatelliteOfficeAccountDescription.web">
              <span class="p-5">
                <p>
                  {{ website.url }}
                  <vs-icon class="ml-10 removeButton" @click="removeSatelliteOfficeSelectedWeb(website)" color="success"
                    icon="clear"></vs-icon>
                </p>
              </span>
            </template>

            <vs-divider class="m-5" />
            <div class="vx-row">
              <h6 class="p-5">Social Media Pages</h6>
            </div>
            <template v-if="
              updateSatelliteOfficeAccountDescription.linkedin &&
              updateSatelliteOfficeAccountDescription.linkedin.length > 0
            ">
            </template>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <vs-input class="w-full" name="linkedin" v-model="SatelliteOfficeaccounts.linkedin" />
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-button color="primary" @click="SatelliteOfficeaddLinkedin" v-validate="'url:require_protocol'"
                  type="filled">Add</vs-button>
                <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('linkedin')">{{ errors.first('linkedin')
                  }}</span>
              </div>

              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{ accountDescription.linkendin }}
              </div>
            </div>

            <template v-for="link in updateSatelliteOfficeAccountDescription.linkedin">
              <span class="p-5">
                <p>
                  {{ link.url }}
                  <vs-icon class="ml-10 removeButton" @click="removeSatelliteOfficeSelectedLinkedin(link)"
                    color="success" icon="clear"></vs-icon>
                </p>
              </span>
            </template>
            <vs-divider class="m-5" />

            <!-- Site Office -->
            <h5 class="mb-5">Site Office Address</h5>
            <template v-for="(
site, index
              ) in updateSatelliteOfficeAccountDescription.satellite_office">
              <div :key="index">
                <vs-divider class="m-5" />
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Address Line 1:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input class="w-full" name="satellite_office_address_1" data-vv-as="Address Line 1"
                      v-model="site.address_1" />
                  </div>
                  <vs-icon class="ml-10 removeButton" @click="SatelliteOfficeremoveSelectedSiteAddress(site)"
                    color="success" icon="clear"></vs-icon>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Address Line 2:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input class="w-full" v-model="site.address_2" />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Address Line 3:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input class="w-full" v-model="site.address_3" />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>City:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input class="w-full" v-model="site.city" />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>County:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input class="w-full" v-model="site.county" />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Postcode:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input class="w-full" v-model="site.postcode" />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Country:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <v-select name="site_country" class="site_country" label="name_1" :options="all_countries"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="site.country" />
                    <!-- <vs-input class="w-full" v-model="site.country" /> -->
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Telephone:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full" v-if="site.phone != null">
                    <div v-if="site.phone.length != 0">
                      <template v-for="(site_ph, ph_index) in site.phone">
                        <div :key="ph_index" v-if="site_ph.satellite_office_id == site.id">
                          <div class="vx-row">
                            <div class="vx-col sm:w-1/2 w-full">
                              <v-select name="phone_code" class="phone_code" label="name_with_code"
                                :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                v-model="site_ph.phone_code" />
                            </div>
                            <div class="vx-col sm:w-1/2 w-full">
                              <vs-input @input="
                                site_ph.phone_no = site_ph.phone_no
                                  .replace(/[^0-9.]/g, '')
                                  .replace(/(\..*?)\..*/g, '$1')
                                " class="w-full" v-model="site_ph.phone_no" />
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>

                    <div class="vx-col w-full" v-else>
                      <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full">
                          <v-select name="phone_code" class="phone_code" label="name_with_code"
                            :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="site.phone_code" />
                        </div>
                        <div class="vx-col sm:w-1/2 w-full">
                          <vs-input class="w-full" @input="
                            site.phone_no = site.phone_no
                              .replace(/[^0-9.]/g, '')
                              .replace(/(\..*?)\..*/g, '$1')
                            " v-model="site.phone_no" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="vx-col sm:w-1/3 w-full" v-else>
                    <div class="vx-row">
                      <div class="vx-col sm:w-1/2 w-full">
                        <v-select name="phone_code" class="phone_code" label="name_with_code" :options="all_phone_codes"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="site.phone_code" />
                      </div>
                      <div class="vx-col sm:w-1/2 w-full">
                        <vs-input class="w-full" @input="
                          site.phone_no = site.phone_no
                            .replace(/[^0-9.]/g, '')
                            .replace(/(\..*?)\..*/g, '$1')
                          " v-model="site.phone_no" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <vs-col class="mb-5" vs-offset="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <vs-button color="primary" @click="SatelliteOfficeaddSiteOffice" type="filled">Add Satellite
                Office</vs-button>
            </vs-col>

            <vs-divider class="m-5" />
            <!-- Telephone -->
            <div class="vx-row">
              <h6 class="p-5">Telephone Number(s)</h6>

              <div class="vx-col sm:w-1/2 w-full">
                <vs-button @click="addSatelliteOfficePhone()" color="primary" type="filled">Add</vs-button>
              </div>

              <div class="vx-col p-5 ml-14" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                <div v-if="accountDescription.switchboard != null">
                  {{ accountDescription.switchboard_phone_code }}
                  {{ accountDescription.switchboard }}
                  <span class="ml-5">{{ 'Head Office Switchboard' }}</span>
                  <br />
                </div>

                {{ accountDescription.phone_code }}
                {{ accountDescription.phone_no }}
                <span class="ml-5">{{ accountDescription.phone_type }}</span>
              </div>
            </div>

            <template v-for="(
w, index
              ) in updateSatelliteOfficeAccountDescription.phone">
              <div class="flex mb-4">
                <div class="w-1/6 bg-grid-color-secondary h-12 mr-5">
                  <v-select name="phone_code" class="phone_code" label="name_with_code" :options="all_phone_codes"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="updateSatelliteOfficeAccountDescription.phone[index][
                      'phone_code'
                    ]
                      " />
                </div>

                <div class="w-1/7 bg-grid-color-secondary h-12 mr-5">
                  <vs-input class="w-full" name="phone" v-model="updateSatelliteOfficeAccountDescription.phone[index][
                    'phone_no'
                  ]
                    " />
                </div>

                <div class="w-1/6 bg-grid-color-secondary h-12 mr-5">
                  <v-select label="name" :options="accounts.phoneTypes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="updateSatelliteOfficeAccountDescription.phone[index][
                    'phone_type'
                  ]
                    " />
                </div>

                <div class="w-1/5 bg-grid-color h-12">
                  <vs-icon class="removeButton" @click="removeSatelliteOfficeSelectedPhone(w)" color="success"
                    icon="clear">
                  </vs-icon>
                </div>
              </div>
            </template>

            <!-- Sic Code -->
            <div class="vx-row">
              <h6 class="p-5">Sic Codes(s)</h6>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <AccountAutocomplete ref="SatelliteOfficeSicCodeRefEdit" class="searchbox" :chosen="selected_sic_code"
                  :list="getSicCodes" :searchOn="'sic_codes'"></AccountAutocomplete>
                <!-- <vs-input
                type="number"
                class="w-full"
                v-model="SatelliteOfficeaccounts.sic_code"
              /> -->
              </div>

              <div class="vx-col sm:w-1/3 w-full">
                <vs-button color="primary" @click="SatelliteOfficeaddSicCodes" type="filled">Add</vs-button>
              </div>

              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
              </div>
            </div>
            <template v-for="sic in SatelliteOfficeaccounts.joinedSicAndDescription">
              <p class="m-10">
                {{ sic.name }}
                <vs-icon class="ml-10 removeButton" @click="removeSatelliteNewSelectedSicCode(sic)" color="success"
                  icon="clear"></vs-icon>
              </p>
            </template>

            <vs-divider class="m-5" />
            <h5 class="mb-5">Other Details</h5>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Registration Jurisdiction:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <AccountAutocomplete ref="SatelliteOfficeEditAccountRegistrationJurisdictionRef"
                  :chosen="selected_registration_jurisdiction" class="searchbox" :list="getCountries"
                  :searchOn="'registration_jurisdiction'">
                </AccountAutocomplete>
              </div>

              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{
                  this.$refs.EditAccountRegistrationJurisdictionRef.$refs
                    .suggestComponent.input.value
                }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Parent Company:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <AccountAutocomplete ref="SatelliteOfficeEditAccountParentRef" class="searchbox"
                  :list="getParentCompany" :searchOn="'parent'">
                </AccountAutocomplete>
              </div>

              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{
                  this.$refs.EditAccountParentRef.$refs.suggestComponent.input
                    .value
                }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Vertical:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <AccountAutocomplete ref="SatelliteOfficeEditAccountVerticalRef" class="searchbox"
                  :chosen="selected_vertical" :list="getVerticals" :searchOn="'vertical'"></AccountAutocomplete>
              </div>

              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{
                  this.$refs.EditAccountVerticalRef.$refs.suggestComponent.input
                    .value
                }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Revenue:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/2 w-full">
                    <v-select label="label" :options="currencyCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="updateSatelliteOfficeAccountDescription.currency_code
                      " />
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input type="number" class="w-full" v-model="updateSatelliteOfficeAccountDescription.revenue" />
                  </div>
                </div>
                <span v-if="satellite_office_currency_code_validation" class="text-danger text-sm mt-2 ml-16">{{
                  satellite_office_currency_code_validation }}</span>
              </div>
              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{ accountDescription.currency_code }}
                {{ accountDescription.revenue }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>No. of Employees:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input type="number" class="w-full" v-model="updateSatelliteOfficeAccountDescription.no_of_employees
                  " />
              </div>

              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{ accountDescription.employees }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Notes:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-textarea class="w-full" v-model="updateSatelliteOfficeAccountDescription.notes" />
              </div>

              <div class="vx-col ml-20" v-if="
                update_account_and_add_to_campaign_heading ==
                'Matched Account Details'
              ">
                {{ accountDescription.notes }}
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full"></div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-button class="mr-3 mb-2" @click.prevent="confirmUpdateMDBAccountForm">Update</vs-button>

                <vs-button class="mr-3 mb-2" @click.prevent="cancelSatelliteOfficeForm">Cancel</vs-button>
              </div>
            </div>
          </vx-card>
        </form>
      </vs-popup>
    </div>

    <vs-popup title="List of Accounts Matched By Website" :active.sync="MatchedWebsitePopupActive">
      <div>
        <vs-list>
          <template v-for="(match, index) in matched_websites">
            <vs-list-item :key="index">
              <p class="p-2">{{ match.company_name }}</p>
              <p class="p-2">{{ match.registered_office_country }}</p>
              <p class="p-2">
                {{ match.company_registration_number
                }}<vs-icon @click.stop="viewPotentialMatchAccountDetails(match)" size="small" icon="info"
                  style="cursor: pointer; margin-left: 15px"></vs-icon>
              </p>
            </vs-list-item>
          </template>

          <div class="vx-row mt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button @click="AddWebsiteAnyWay()" class="mr-3 mb-2">Submit Anyway</vs-button>

              <vs-button @click="CancelWebsitePopup()" class="mr-3 mb-2">Cancel</vs-button>
            </div>
          </div>
        </vs-list>
      </div>
    </vs-popup>

    <vs-popup title="List of Accounts Matched By LinkedIn" :active.sync="MatchedLinkedInPopupActive">
      <div>
        <vs-list>
          <template v-for="(match, index) in matched_linkedins">
            <vs-list-item :key="index">
              <p class="p-2">{{ match.company_name }}</p>
              <p class="p-2">{{ match.registered_office_country }}</p>
              <p class="p-2">
                {{ match.company_registration_number
                }}<vs-icon @click.stop="viewPotentialMatchAccountDetails(match)" size="small" icon="info"
                  style="cursor: pointer; margin-left: 15px"></vs-icon>
              </p>
            </vs-list-item>
          </template>

          <div class="vx-row mt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button @click="AddLinkedInAnyWay()" class="mr-3 mb-2">Submit Anyway</vs-button>

              <vs-button @click="CancelLinkedInPopup()" class="mr-3 mb-2">Cancel</vs-button>
            </div>
          </div>
        </vs-list>
      </div>
    </vs-popup>
    <vs-popup title="Account already matches other accounts in master database"
      :active.sync="MatchedAccountsPopupActive">
      <div>
        <vs-list>
          <template v-for="(match, index) in submit_match_accounts">
            <vs-list-item :key="index">
              <p class="p-2">{{ match.company_name }}</p>
              <p class="p-2">{{ match.registered_office_country }}</p>
              <p class="p-2">
                {{ match.company_registration_number
                }}<vs-icon @click.stop="viewPotentialMatchAccountDetails(match)" size="small" icon="info"
                  style="cursor: pointer; margin-left: 15px"></vs-icon>
              </p>
            </vs-list-item>
          </template>

          <div class="vx-row mt-5"></div>
        </vs-list>
      </div>
    </vs-popup>




    <vx-card class="vxtable" v-if="showContactForm">

      <vs-row vs-w="12" class="mb-10">
        <vs-col vs-lg="4" vs-sm="4" vs-xs="12">

        </vs-col>



        <vs-col vs-lg="5" vs-sm="5" vs-xs="12">
          <h3> Contact </h3>
        </vs-col>



        <vs-col vs-lg="3" vs-sm="3" vs-xs="12">








        </vs-col>
      </vs-row>








      <vs-row vs-w="12" class="mb-5">
        <vs-col vs-lg="10" vs-sm="10" vs-xs="12">

          <form data-vv-scope="AddNewContactForm">



            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Title:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" name="title" v-model="contactDescription.title" data-vv-as="Title" />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Forename:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" name="AddNewContactForm.forename" data-vv-as="Forename" v-validate="'required'"
                  v-model="contactDescription.forename" />
              </div>
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('AddNewContactForm.forename')">{{
                errors.first('AddNewContactForm.forename')
              }}</span>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Surname:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" name="AddNewContactForm.surname" data-vv-as="Surname" v-validate="'required'"
                  v-model="contactDescription.surname" />
              </div>
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('AddNewContactForm.surname')">{{
                errors.first('AddNewContactForm.surname')
              }}</span>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Job Title:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input v-validate="'required'" name="AddNewContactForm.job_title" data-vv-as="Job Title"
                  class="w-full" v-model="contactDescription.job_title" />
              </div>
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('AddNewContactForm.job_title')">{{
                errors.first('AddNewContactForm.job_title')
              }}</span>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Seniority:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <div :class="{
                  correction_field_input_class:
                    correction_fields_array.includes('seniority')
                }">
                  <v-select name="seniority" data-vv-as="Seniority" label="seniority" :options="contacts.seniorities"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="contactDescription.seniority" />
                </div>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Role:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <div :class="{
                  correction_field_input_class:
                    correction_fields_array.includes('role')
                }">
                  <v-select data-vv-as="Role" name="role" label="role" :options="contacts.roles"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="contactDescription.role" />
                </div>
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Sub Role:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <v-select data-vv-as="Sub Role" name="sub_role" label="sub_role" :options="contacts.sub_roles"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="contactDescription.sub_role" />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <h5 class="mb-5">Email</h5>

                <div class="vx-row p-2">
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input class="w-full" name="email" v-model="contactDescription.email" data-vv-as="Email" />
                  </div>

                  <vs-button color="primary" @click="validateEmailZeroBounce(contactDescription.email)"
                    type="filled">Check
                    & Add</vs-button>

                  <span class="ml-5">{{ email_validate_status }} </span>
                </div>
              </div>
              <div class="vx-col sm:w-1/2 w-full"></div>
            </div>

            <template v-for="(email, index) in contactDescription.emails">
              <div class="m-5">
                {{ email.email }}

                <vs-icon class="removeButton" @click="removeSelectedEmail(email)" color="success" icon="clear">
                </vs-icon>
              </div>
            </template>



            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <h5 class="mb-5">Social Media</h5>

                <div class="vx-row p-2">
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input class="w-full" name="social_media" v-model="contactDescription.social_media"
                      data-vv-as="Social Media" />
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-textarea v-model="contactDescription.summary" />






                  </div>



                </div>
              </div>
              <div class="vx-col sm:w-1/5 w-full">
                <vs-button color="primary"
                  @click="addSocialMedia(contactDescription.social_media, contactDescription.summary)"
                  type="filled">Check
                  & Add</vs-button>
              </div>
            </div>

            <template v-for="(social_media, index) in contactDescription.social_medias">
              <div class="m-5">
                {{ social_media.social_media }} {{ ' - ' + social_media.summary }}

                <vs-icon class="removeButton" @click="removeSelectedSocialMedia(social_media)" color="success"
                  icon="clear">
                </vs-icon>
              </div>
            </template>




            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <h5 class="mb-5">DDI</h5>
              </div>
              <div class="vx-col sm:w-1/5 w-full">
                <vs-button color="primary" @click="addDDI" type="filled">Add</vs-button>
              </div>
            </div>

            <template v-for="(ddi, index) in contactDescription.ddis">
              <div class="vx-row p-2">
                <div class="vx-col sm:w-1/5 w-full">
                  <div :class="{
                    correction_field_input_class:
                      correction_fields_array.includes('ddi_phone_code')
                  }">
                    <v-select name="ddi_phone_code" class="ddi_phone_code" label="name_with_code"
                      :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="ddi.ddi_phone_code" />
                  </div>

                  <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('ddi')">{{ errors.first('ddi')
                  }}</span>
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                  <vs-input class="w-full" name="ddi" v-model="ddi.ddi" data-vv-as="DDI" />
                </div>

                <div class="vx-col sm:w-1/5 w-full">
                  <!-- <vs-radio
              v-model="ddi.primary"
              :vs-value="ddi.primary"
              class="mr-4"
              vs-name="primary_ddi"
            ></vs-radio
            > -->

                  <vs-icon class="removeButton" @click="removeSelectedDDI(ddi)" color="success" icon="clear">
                  </vs-icon>
                </div>
              </div>
            </template>


            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <h5 class="mb-5">Mobile</h5>
              </div>
              <div class="vx-col sm:w-1/5 w-full">
                <vs-button color="primary" @click="addMobile" type="filled">Add</vs-button>
              </div>
            </div>

            <template v-for="(mobile, index) in contactDescription.mobiles">
              <div class="vx-row p-2">
                <div class="vx-col sm:w-1/5 w-full">
                  <div :class="{
                    correction_field_input_class:
                      correction_fields_array.includes('mobile_phone_code')
                  }">
                    <v-select name="mobile_phone_code" class="mobile_phone_code" label="name_with_code"
                      :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="mobile.mobile_phone_code" />
                  </div>

                  <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('mobile')">{{ errors.first('mobile')
                  }}</span>
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                  <vs-input class="w-full" name="mobile" v-model="mobile.mobile" data-vv-as="Mobile" />
                </div>

                <div class="vx-col sm:w-1/5 w-full">


                  <vs-icon class="removeButton" @click="removeSelectedMobile(mobile)" color="success" icon="clear">
                  </vs-icon>
                </div>
              </div>
            </template>

            <div class="vx-row mt-10">
              <div class="vx-col sm:w-1/5 w-full"></div>
              <div class="vx-col sm:w-1/3 w-full">


                <vs-button :disabled="accountDescription.matched_account_id == null" class="mr-3"
                  @click.prevent="submitContactForm">Submit</vs-button>
              </div>

            </div>
          </form>




        </vs-col>

        <vs-col vs-lg="2" vs-sm="2" vs-xs="12">


          <div class="m-2 mt-5">
            <u>
              <h4> Potential Matches</h4>
            </u>
          </div>



          <div>
            <template v-for="(match, index) in potential_contact_matches">
              <p class="p-2">
                {{ match.title }} {{ match.forename }} {{ match.surname }}
                <vs-icon @click.stop="viewPotentialMatchContactDetails(match)" size="small" icon="info"
                  style="cursor: pointer; margin-left: 15px"></vs-icon>
              </p>


              <p class="p-2">{{ match.job_title }}</p>
              <p class="p-2">{{ match.email }}</p>
              <p class="p-2">{{ match.social_media }}</p>
              <p class="p-2">{{ match.role }}</p>
              <p class="p-2">{{ match.seniority }}</p>

              <vs-divider class="m-5" />
            </template>
          </div>





        </vs-col>











      </vs-row>


















    </vx-card>

    <vx-card class="vxtable"">


            <vs-row>
               

             <vs-col  vs-w=" 4">

      <div class="info-section m-5 text-info">
        <i>
          <p>Note: <span class="text-danger">*</span></p>
          <p>1. Account & Contact should be added to Master Database</p>
          <p>2. Reason of Request is required</p>
        </i>
      </div>

      </vs-col>

      <vs-col vs-w="6">

        <div class="vx-row w-full mt-5">






          <h6>Reason for Request:</h6>


          <div class="vx-col sm:w-1/2 w-full">
            <vs-textarea v-validate="'required'" class="w-full" name="data_administrator_reason_for_request"
              v-model="data_administrator_reason_for_request" data-vv-as="Reason For Request" />






            <vs-button
              :disabled="accountDescription.matched_account_id == null || (Object.keys(contactDescription).length != 0 && contactDescription.matched_contact_id == null) || data_administrator_reason_for_request == null || data_administrator_reason_for_request.trim() == ''"
              class="mt-5 build-complete" @click.prevent="AccountContactRequestComplete">Request Complete </vs-button>
          </div>
          <div class="vx-col sm:w-1/4 w-full"></div>
        </div>
      </vs-col>
      <vs-col vs-w="2">

      </vs-col>



      </vs-row>
    </vx-card>




    <vs-popup fullscreen title="Contact Details" v-if="showUpdateSContactDetailsPopup"
      :active.sync="updateContactsDetailsPopupActive">
      <div class="p-5">
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <h3></h3>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <h6><u>Master Database</u></h6>
          </div>

          <div class="vx-col sm:w-1/3 w-full ml-10">
            <h6><u>Request Contact</u></h6>
          </div>

        </div>


        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Title:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input class="w-full" name="title" v-model="updateContactDescription.title" v-validate="'required'"
              data-vv-as="Title" />
          </div>

          <div class="vx-col sm:w-1/3 w-full ml-10">
            <span>{{ contactDescription.title }}</span>
          </div>
          <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('title')">{{ errors.first("title") }}</span>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Forename:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input class="w-full" name="forename" data-vv-as="Forename" v-validate="'required'"
              v-model="updateContactDescription.forename" />
          </div>
          <div class="vx-col sm:w-1/3 w-full ml-10">
            <span>{{ contactDescription.forename }}</span>
          </div>
          <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('forename')">{{ errors.first("forename")
            }}</span>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Surname:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input class="w-full" name="surname" data-vv-as="Surname" v-validate="'required'"
              v-model="updateContactDescription.surname" />
          </div>
          <div class="vx-col sm:w-1/3 w-full ml-10">
            <span>{{ contactDescription.surname }}</span>
          </div>
          <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('surname')">{{ errors.first("surname")
            }}</span>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Job Title:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input v-validate="'required'" name="job_title" data-vv-as="Job Title" class="w-full"
              v-model="updateContactDescription.job_title" />

          </div>
          <div class="vx-col sm:w-1/3 w-full ml-10">
            <span>{{ contactDescription.job_title }}</span>
          </div>
          <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('job_title')">{{ errors.first("job_title")
            }}</span>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Seniority:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <v-select name="seniority" data-vv-as="Seniority" label="seniority" :options="contacts.seniorities"
              :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="updateContactDescription.seniority" />
          </div>
          <div class="vx-col sm:w-1/3 w-full ml-10">
            <span>{{ typeof contactDescription.seniority == 'object' && contactDescription.seniority !== null ?
              contactDescription.seniority.seniority : contactDescription.seniority }}</span>
          </div>

        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Role:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <v-select data-vv-as="Role" name="role" label="role" :options="contacts.roles"
              :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="updateContactDescription.role" />
          </div>
          <div class="vx-col sm:w-1/3 w-full ml-10">
            <span>{{ typeof contactDescription.role == 'object' && contactDescription.role !== null ?
              contactDescription.role.role : contactDescription.role }}</span>
          </div>

        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Sub Role:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <v-select data-vv-as="Sub Role" name="sub_role" label="sub_role" :options="contacts.sub_roles"
              :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="updateContactDescription.sub_role" />
          </div>

          <div class="vx-col sm:w-1/3 w-full ml-10">
            <span>{{ typeof contactDescription.sub_role == 'object' && contactDescription.sub_role !== null ?
              contactDescription.sub_role.sub_role : contactDescription.sub_role }}</span>
          </div>

        </div>
        <div class="vx-row mb-6">

          <div class="vx-col sm:w-1/6 w-full">
            <h5 class="mb-5">Email

            </h5>



          </div>
          <div class="vx-col sm:w-1/5 w-full">

            <vs-button color="primary" @click="addUpdateContactDescriptionEmail" type="filled">Add</vs-button>
          </div>
        </div>


        <template v-for="(email, index) in updateContactDescription.emails">




          <div class="vx-row p-2">
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input class="w-full" name="email" v-model="email.email" data-vv-as="Email" />
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('email')">{{ errors.first("email")
                }}</span>
            </div>


            <div class="vx-col sm:w-1/5 w-full">

              <vs-icon style="cursor:pointer;" @click="validateUpdateContactDescriptionEmailZeroBounce(email.email)"
                color="success" icon="checkmark"></vs-icon>


              <!-- <vs-radio
              v-model="email.primary"
              :vs-value="email.primary"
              class="mr-4"
              vs-name="primary_email"
            ></vs-radio
            > -->


              <vs-icon class="removeButton" @click="removeSelectedUpdateContactDescriptionEmail(email)" color="success"
                icon="clear">
              </vs-icon>
            </div>

            <div class="vx-col sm:w-1/3 w-full ml-10">
              <span>{{ contactDescription.emails.length > 0 ? contactDescription.emails[0].email : '' }}</span>
            </div>

          </div>


        </template>
        {{ email_validate_status }}

        <vs-divider class="m-5" />


        <div class="vx-row mb-6">

          <div class="vx-col sm:w-1/6 w-full">
            <h5 class="mb-5">Social Media Pages
            </h5>


          </div>
          <div class="vx-col sm:w-1/5 w-full">

            <vs-button color="primary" @click="addUpdateContactDescriptionSocialMedia" type="filled">Add</vs-button>
          </div>
        </div>


        <template v-for="(social_media, index) in updateContactDescription.social_medias">


          <div class="vx-row">
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input class="w-full" name="social_media" v-model="social_media.social_media"
                data-vv-as="Social Media" />
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('social_media')">{{
                errors.first("social_media") }}</span>
            </div>
            <div class="vx-col sm:w-1/5 w-full">
              <vs-textarea v-model="social_media.summary" />






            </div>



            <div class="vx-col sm:w-1/5 w-full">

              <!-- <vs-radio
              v-model="social_media.primary"
              :vs-value="social_media.primary"
              class="mr-4"
              vs-name="primary_social_media"
            ></vs-radio
            > -->


              <vs-icon class="removeButton" @click="removeSelectedUpdateContactDescriptionSocialMedia(social_media)"
                color="success" icon="clear">
              </vs-icon>
            </div>

            <div class="vx-col sm:w-1/3 w-full ml-10">

              <template v-for="s in contactDescription.social_medias">

                <span>{{ s.social_media }} {{ ' - ' +
                  s.summary }}</span>

              </template>



            </div>

          </div>


        </template>


        <vs-divider class="m-5" />

        <div class="vx-row mb-6">

          <div class="vx-col sm:w-1/6 w-full">
            <h5 class="mb-5">DDI
            </h5>


          </div>
          <div class="vx-col sm:w-1/5 w-full">

            <vs-button color="primary" @click="addUpdateContactDescriptionDDI" type="filled">Add</vs-button>
          </div>
        </div>


        <template v-for="(ddi, index) in updateContactDescription.ddis">


          <div class="vx-row p-2">
            <div class="vx-col sm:w-1/5 w-full">


              <v-select name="phone_code" class="phone_code" label="name_with_code" :options="all_phone_codes"
                :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="ddi.ddi_phone_code" />

              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('ddi')">{{ errors.first("ddi") }}</span>
            </div>
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input class="w-full" name="ddi" v-model="ddi.ddi" data-vv-as="DDI" />






            </div>

            <div class="vx-col sm:w-1/5 w-full">

              <!-- <vs-radio
              v-model="ddi.primary"
              :vs-value="ddi.primary"
              class="mr-4"
              vs-name="primary_ddi"
            ></vs-radio
            > -->


              <vs-icon class="removeButton" @click="removeSelectedUpdateContactDescriptionDDI(ddi)" color="success"
                icon="clear">
              </vs-icon>
            </div>

            <div class="vx-col sm:w-1/3 w-full ml-10">

              <template v-for="ddi in contactDescription.ddis">

                <span>{{ ddi.ddi_phone_code }} {{ '-' +
                  ddi.ddi }}</span>

              </template>



            </div>

          </div>


        </template>

        <vs-divider class="m-5" />

        <div class="vx-row mb-6">

          <div class="vx-col sm:w-1/6 w-full">
            <h5 class="mb-5">Mobile
            </h5>


          </div>
          <div class="vx-col sm:w-1/5 w-full">

            <vs-button color="primary" @click="addUpdateContactDescriptionMobile" type="filled">Add</vs-button>
          </div>
        </div>


        <template v-for="(mobile, index) in updateContactDescription.mobiles">


          <div class="vx-row p-2">
            <div class="vx-col sm:w-1/5 w-full">


              <v-select name="phone_code" class="phone_code" label="name_with_code" :options="all_phone_codes"
                :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="mobile.mobile_phone_code" />

              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('mobile')">{{ errors.first("mobile")
                }}</span>
            </div>
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input class="w-full" name="mobile" v-model="mobile.mobile" data-vv-as="Mobile" />






            </div>

            <div class="vx-col sm:w-1/5 w-full">


              <!-- <vs-radio
              v-model="mobile.primary"
              :vs-value="mobile.primary"
              class="mr-4"
              vs-name="primary_mobile"
            ></vs-radio
            > -->


              <vs-icon class="removeButton" @click="removeSelectedUpdateContactDescriptionMobile(mobile)"
                color="success" icon="clear">
              </vs-icon>
            </div>



            <div class="vx-col sm:w-1/3 w-full ml-10">


              <template v-for="mobile in contactDescription.mobiles">

                <span>{{ mobile.mobile_phone_code }} {{ '-' +
                  mobile.mobile }}</span>

              </template>


            </div>

          </div>


        </template>
        <vs-divider class="m-10" />


        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full"></div>
          <div class="vx-col sm:w-1/2 w-full">
            <vs-button class="mr-3 mb-2" @click.prevent="confirmUpdateMDBContact">Update</vs-button>

            <vs-button class="mr-3 mb-2" @click.prevent="cancelContactDescriptionForm">Cancel</vs-button>
          </div>



        </div>

      </div>
    </vs-popup>

    <vs-popup title="List of contacts Matched By Email" :active.sync="MatchedEmailPopupActive">
      <div>
        <vs-list>
          <template v-for="(match, index) in matched_emails">
            <vs-list-item :key="index">
              <p class="p-2">
                {{ match.title }} {{ match.forename }} {{ match.surname }}
                <vs-icon @click.stop="viewPotentialMatchContactDetails(match)" size="small" icon="info"
                  style="cursor: pointer; margin-left: 15px"></vs-icon>
              </p>
              <p class="p-2">{{ match.job_title }}</p>
              <p class="p-2">{{ match.email }}</p>
              <p class="p-2">{{ match.social_media }}</p>
              <p class="p-2">{{ match.role }}</p>
              <p class="p-2">{{ match.seniority }}</p>
            </vs-list-item>
          </template>

          <div class="vx-row mt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">

              <vs-button @click="CancelEmailPopup()" class="mr-3 mb-2">Cancel</vs-button>
            </div>
          </div>
        </vs-list>
      </div>
    </vs-popup>

    <vs-popup title="List of contacts Matched By Social Media" :active.sync="MatchedSocialMediaPopupActive">
      <div>
        <vs-list>
          <template v-for="(match, index) in matched_social_medias">
            <vs-list-item :key="index">
              <p class="p-2">
                {{ match.title }} {{ match.forename }} {{ match.surname }}
                <vs-icon @click.stop="viewPotentialMatchContactDetails(match)" size="small" icon="info"
                  style="cursor: pointer; margin-left: 15px"></vs-icon>
              </p>
              <p class="p-2">{{ match.job_title }}</p>
              <p class="p-2">{{ match.email }}</p>
              <p class="p-2">{{ match.social_media }}</p>
              <p class="p-2">{{ match.role }}</p>
              <p class="p-2">{{ match.seniority }}</p>

              <vs-divider class="m-5" />
            </vs-list-item>
          </template>

          <div class="vx-row mt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">

              <vs-button @click="CancelSocialMediaPopup()" class="mr-3 mb-2">Cancel</vs-button>
            </div>
          </div>
        </vs-list>
      </div>
    </vs-popup>

    <vs-popup title="Very Close Matches Found In Database" :active.sync="MatchedContactsPopupActive">
      <div>
        <vs-list>
          <template v-for="(match, index) in submit_match_contacts">
            <vs-list-item :key="index">
              <p class="p-2">
                {{ match.title }} {{ match.forename }} {{ match.surname }}
                <vs-icon @click.stop="viewPotentialMatchContactDetails(match)" size="small" icon="info"
                  style="cursor: pointer; margin-left: 15px"></vs-icon>
              </p>
              <p class="p-2">{{ match.job_title }}</p>
              <p class="p-2">{{ match.email }}</p>
              <p class="p-2">{{ match.social_media }}</p>
              <p class="p-2">{{ match.role }}</p>
              <p class="p-2">{{ match.seniority }}</p>

            </vs-list-item>
          </template>


          <div class="vx-row mt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button @click="submitFormAnyway()" class="mr-3 mb-2">Submit</vs-button>

              <vs-button @click="cancelSubmitFormAnyway()" class="mr-3 mb-2">Cancel</vs-button>
            </div>
          </div>
        </vs-list>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import moduleContactsManagement from '@/store/contacts-management/moduleContactsManagement.js'
import moduleAccountsManagement from '@/store/accounts-management/moduleAccountsManagement.js'
import _ from 'lodash'
import defineAbilitiesFor from '@/config/abilities'
import axios from '@/axios.js'
import moduleCampaignsManagement from '@/store/campaign-management/moduleCampaignManagement.js'
import AccountAutocomplete from '@/components/autocomplete/AccountsAutocomplete.vue'
import AccountDisabledAutocomplete from '@/components/autocomplete/AccountsAutocompleteDisabled.vue'
import moduleSDSubStatusManagement from "@/store/sd-sub-status-management/moduleSDSubStatusManagement.js";
import Autocomplete from '@/components/autocomplete/Autocomplete.vue'
import vSelect from 'vue-select'
import ProgressBar from 'vue-simple-progress'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { remove } from 'lodash'
export default {
  components: {
    Autocomplete,
    'v-select': vSelect,
    ProgressBar,
    flatPickr,
    AccountAutocomplete,
    AccountDisabledAutocomplete
  },
  computed: {
    total_pages() {
      console.log('totla', this.all_total)
      return Math.ceil(this.all_total / this.limit)
    }
    // cloneItems() {
    //     var clone = this.unmatch_contacts;
    //     var startFrom = (this.pagination.page*this.pagination.rowsPerPage)-this.pagination.rowsPerPage;
    //     return clone.splice(startFrom, this.pagination.rowsPerPage);
    // }
  },
  data() {
    return {
      data_administrator_reason_for_request: null,
      request_contact_details: {},
      SatelliteOfficeaccounts: {
        web: null,
        phone: null,
        linkedin: null,
        main_counter: 0,
        vertical: null,
        phoneTypes: [],
        phoneType: [],
        joinedPhoneAndTypes: [],
        joinedSicAndDescription: [],
        websites: [],
        linkedins: [],
        phoneWithTypes: [],
        sicCodeWithDescription: [],
        verticals: [],
        vertical: null,
        sic_code: null,
        sic_code_description: null,
        currency_code: null,
        revenue: null,
        no_of_employees: null,
        satellite_office: []

      },
      updateSatelliteOfficeAccountDescription: {},
      updateSatelliteOfficePopupActive: false,
      update_account_and_add_to_campaign_heading:
        'Update Account',
      overwriteDataBuildRegisteredOfficeAddressToMasterDB: false,
      overwriteDataBuildHeadOfficeAddressToMasterDB: false,
      matched_websites: [],
      matched_linkedins: [],
      submit_match_accounts: [],
      MatchedAccountsPopupActive: false,
      MatchedWebsitePopupActive: false,
      MatchedLinkedInPopupActive: false,
      showUpdateSatelliteOfficePopup: false,
      accountExists: false,
      websiteExists: false,
      linkedinExists: false,
      potential_account_matches: [],
      showContactForm: true,
      selected_status_notes: null,
      user_role_id: null,
      account_sub_statuses: [],
      selected_account_sub_status: [],

      please_choose_status: null,
      selected_status: null,

      all_sd_status: [],
      accounts: {
        web: null,
        phone: null,
        linkedin: null,
        main_counter: 0,
        vertical: null,
        phoneTypes: [],
        phoneType: [],
        phone_code: null,
        joinedPhoneAndTypes: [],
        joinedSicAndDescription: [],
        websites: [],
        linkedins: [],
        phoneWithTypes: [],
        verticals: [],
        vertical: null,
        sic_code: null,
        sic_code_description: null,
        currency_code: null,
        revenue: null,
        no_of_employees: null,
        notes: null,
        satellite_office: []
      },
      accountDescription: {},
      isChecked: true,
      existed_contact_ids: [],
      RegistrationJurisdiction: null,
      viewAccountDescription: {},
      showUpdateSAccountDetailsPopup: false,
      updateAccountDetailsPopupActive: false,
      selected_existing_master_database_contacts: [],
      scrollClass: 'scroll-container',
      existing_master_database_contacts: [],
      existing_campaign_contact_matches: [],
      showUpdateSContactDetailsPopup: false,
      showAddressField: false,

      account_validation: null,
      updateContactDescription: {},
      updateContactsDetailsPopupActive: false,
      editContacts: {
        account_id: null,
        primary_social_media: null,
        primary_mobile: null,
        primary_ddi: null,

        edit_primary_email: null,
        company_name: null,
        social_medias: [],
        mobiles: [],
        ddis: [],

        emails: [],
        title: null,
        forename: null,
        surname: null,
        email: null,
        job_title: null,
        ddi: null,
        mobile: null,
        ddi: null,

        seniority: null,
        role: null,
        sub_role: null,
        social_media: null,
        seniorities: [],
        sub_roles: [],
        satellite_address: {},
        satellite_office_id: null
      },

      email_validate_status: null,
      contact_validation: null,
      companySearchComponentKey: 0,
      update_contact_and_add_to_campaign_heading:
        'Update contact and Add to Campaign',
      subsidiaryPopupActive: false,
      temp_table_id: null,
      submit_match_contacts: [],
      MatchedContactsPopupActive: false,
      MatchedEmailPopupActive: false,
      MatchedSocialMediaPopupActive: false,
      subsidiarycontactDescription: {},
      updateSatelliteOfficecontactDescription: {},
      all_phone_codes: [],
      head_office_country_validation: null,
      potential_contact_matches: [],
      matched_emails: [],
      matched_social_medias: [],
      user_id: null,
      user_role: null,
      registered_office_country_validation: null,
      selected_parent_company: null,
      selected_registration_jurisdiction: null,
      selected_vertical: null,
      selected_sic_code: null,
      selected_registered_office_country: null,
      selected_head_office_country: null,
      satellite_office_currency_code_validation: null,
      abilities: null,
      showHeadOfficeCountryField: true,
      showEditAutocomplete: false,
      telephone_show_no: 5,
      linkedin_show_no: 5,
      website_show_no: 5,
      popupActive: false,
      websiteExists: false,
      linkedinExists: false,
      parent_name: null,
      RegistrationJurisdiction: null,
      verticalName: null,
      headOfficeIsRegisteredOffice: false,
      satelliteOfficeheadOfficeIsRegisteredOffice: false,
      subsidiaryheadOfficeIsRegisteredOffice: false,
      overwriteDataBuildRegisteredOfficeAddressToMasterDB: false,
      overwriteDataBuildHeadOfficeAddressToMasterDB: false,
      old_head_office_address_1: null,
      old_head_office_address_2: null,
      old_head_office_address_3: null,
      old_head_office_city: null,
      old_head_office_county: null,
      old_head_office_postcode: null,
      old_head_office_country: null,
      old_head_office_address_1_update_satellite_office: null,
      old_head_office_address_2_update_satellite_office: null,
      old_head_office_address_3_update_satellite_office: null,
      old_head_office_city_update_satellite_office: null,
      old_head_office_county_update_satellite_office: null,
      old_head_office_postcode_update_satellite_office: null,
      old_head_office_country_update_satellite_office: null,
      old_registered_office_address_1_update_satellite_office: null,
      old_registered_office_address_2_update_satellite_office: null,
      old_registered_office_address_3_update_satellite_office: null,
      old_registered_office_city_update_satellite_office: null,
      old_registered_office_county_update_satellite_office: null,
      old_registered_office_postcode_update_satellite_office: null,
      old_registered_office_country_update_satellite_office: null,
      old_head_office_address_1_subsidiary: null,
      old_head_office_address_2_subsidiary: null,
      old_head_office_address_3_subsidiary: null,
      old_head_office_city_subsidiary: null,
      old_head_office_county_subsidiary: null,
      old_head_office_postcode_subsidiary: null,
      old_head_office_country_subsidiary: null,
      old_registered_office_address_1_subsidiary: null,
      old_registered_office_address_2_subsidiary: null,
      old_registered_office_address_3_subsidiary: null,
      old_registered_office_city_subsidiary: null,
      old_registered_office_county_subsidiary: null,
      old_registered_office_postcode_subsidiary: null,
      old_registered_office_country_subsidiary: null,
      old_company_registration_number: null,
      IsSoleTrader: false,
      registered_office_country_validation: null,
      head_office_country_validation: null,

      configDatePicker: {
        enableTime: false,
        dateFormat: 'Y-m-d',
        allowInvalidPreload: false
      },
      configDateAndTimePicker: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i:s',
        allowInvalidPreload: false,
        enableSeconds: true
      },
      PLeasewait: '',
      uploadPercentage: 0,
      request_accounts: [],
      selected: [],
      allSelected: false,
      all_currency_codes: [],
      all_verticals: [],
      all_sic_codes: [],
      all_countries: [],
      contactDescription: {},
      mandatory_fields: [],
      selected_fields: null,
      correction_fields_array: [],
      vertical: null,
      selected_vertical: null,
      correction_fields: null,
      selected_registration_jurisdiction: null,
      selected_sic_code: null,
      add_or_update_title: null,
      user_id: null,
      user_role: null,
      selected_head_office_country: null,
      abilities: null,
      field_array_columns: [],
      actual_contact_name: null,
      registered_office_address_1: null,
      registered_office_address_2: null,
      registered_office_address_3: null,
      registered_office_city: null,
      registered_office_county: null,
      registered_office_postcode: null,
      registered_office_country: null,
      head_office_address_1: null,
      head_office_address_2: null,
      head_office_address_3: null,
      head_office_city: null,
      head_office_county: null,
      head_office_postcode: null,
      company_category: null,
      sic_code: null,
      revenue: null,
      currency_code: null,
      registration_jurisdiction: null,
      no_of_employees: null,
      // sic_code_description: null,
      phone_type: null,
      phone_no: null,
      phone_code: null,
      website: null,
      linkedin: null,
      status: null,
      switchboard: null,
      switchboard_phone_code: null,
      site_switchboard: null,
      site_switchboard_phone_code: null,
      company_name: null,
      selected_fields: null,
      registered_office_country_validation: null,
      EnhancedHeadOfficeAutocompleteComponentKey: 0,
      EnhancedRegOfficeAutocompleteComponentKey: 0,
      EnhancedSicCodeAutocompleteComponentKey: 0,
      EnhancedVerticalAutocompleteComponentKey: 0,
      EnhancedRegistrationJurisdictionAutocompleteComponentKey: 0,
      company_registration_number: null,
      country: null,
      isNewcontact: null,
      update_id: null,
      table: null,
      popupActive: false,
      updateData: [],
      currency_code_validation: null,
      currencyCodes: [],
      abilities: null,
      showHeadOfficeCountryField: true,
      showEditAutocomplete: false,
      telephone_show_no: 5,
      linkedin_show_no: 5,
      website_show_no: 5,
      contactExists: false,
      websiteExists: false,
      linkedinExists: false,
      parent_name: null,
      RegistrationJurisdiction: null,
      verticalName: null,
      old_head_office_address_1: null,
      old_head_office_address_2: null,
      old_head_office_address_3: null,
      old_head_office_city: null,
      old_head_office_county: null,
      old_head_office_postcode: null,
      old_head_office_country: null,
      old_company_registration_number: null,
      contacts: {
        account_id: null,
        primary_social_media: null,
        primary_mobile: null,
        primary_ddi: null,

        primary_email: null,
        company_name: null,
        social_medias: [],
        mobiles: [],
        ddis: [],

        emails: [],
        title: null,
        forename: null,
        surname: null,
        email: null,
        job_title: null,
        ddi: null,
        mobile: null,
        ddi: null,

        seniority: null,
        role: null,
        sub_role: null,
        social_media: null,
        seniorities: [],
        sub_roles: [],
        satellite_address: {},
        satellite_office_id: null
      },
      addNewcontactsPopUp: false,
      campaignDescription: [],
      abilities: null,
      campaignId: null,
      componentKey: 0,
      limit: 1,
      currentx: 1,
      paginate: { limit: 1, offset: 0 },
      tableData: [],
      header: [],
      sheetName: '',
      list2: [],
      uploaded_columns: [],
      selected_fields: [
        'ml_company',
        'ml_actual_contact_name',
        [
          [
            'Head Office Address',
            'Registered Office',
            'State',
            'Town',
            'Country',
            'Postal Code',
            'Site Office'
          ]
        ]
      ],
      unmatch_contacts: [],
      accept_text: 'Accept',
      acceptButtonColor: 'primary',
      accepted_matches: [],
      combined_matches: [],
      all_total: 0
    }
  },
  mounted() {
    this.getAllPhoneCodes()
    this.getCampaignDescription()
    this.requestIndividualAccountById()
    this.getSeniority()
    this.getRoles()
  },
  watch: {
    'SatelliteOfficeaccounts.websites'(val) {
      if (val) {
        var lastItem = val[val.length - 1]
        if (this.validDomain(lastItem)) {
          this.$store
            .dispatch('accountsManagement/checkWebsiteExists', lastItem)
            .then(res => {
              if (res.data.status == 'fail') {
                this.websiteExists = true
                this.$vs.dialog({
                  color: 'primary',
                  title: `Confirm`,
                  text: 'This website already exists.',
                  accept: (this.websiteExists = false)
                })
                var index = this.accounts.websites.indexOf(lastItem)
                this.accounts.websites.splice(index, 1)
              } else {
                return
              }
            })
            .catch(err => {
              if (err.response.status === 401) {
                this.$router.replace('/login')
              }
            })
        } else {
          var index = this.accounts.websites.indexOf(lastItem)
          this.accounts.websites.splice(index, 1)
          return false
        }
      }
    },
    'SatelliteOfficeaccounts.linkedins'(val) {
      if (val) {
        var lastItem = val[val.length - 1]
        if (this.validDomain(lastItem)) {
          this.$store
            .dispatch('accountsManagement/checkLinkedinExists', lastItem)
            .then(res => {
              if (res.data.status == 'fail') {
                this.linkedinExists = true
                this.$vs.dialog({
                  color: 'primary',
                  title: `Confirm`,
                  text: 'This linkedin already exists.',
                  accept: (this.linkedinExists = false)
                })
                var index = this.accounts.linkedins.indexOf(lastItem)
                this.accounts.linkedins.splice(index, 1)
              } else {
                return
              }
            })
            .catch(err => {
              if (err.response.status === 401) {
                this.$router.replace('/login')
              }
            })
        } else {
          var index = this.accounts.linkedins.indexOf(lastItem)
          this.accounts.linkedins.splice(index, 1)
          return false
        }
      }
    },
    selected_status(val) {
      if (val) {
        console.log("STATUS CHANGED", this.user_role_id)
        this.fetchSDSubStatusByStatusIDAndRoleID(val.id, this.user_role_id)
      }
    },
    headOfficeIsRegisteredOffice(val) {
      if (val) {
        this.accountDescription.head_office_address_1 = this.accountDescription.registered_office_address_1;
        this.accountDescription.head_office_address_2 = this.accountDescription.registered_office_address_2;
        this.accountDescription.head_office_address_3 = this.accountDescription.registered_office_address_3;
        this.accountDescription.head_office_city = this.accountDescription.registered_office_city;
        this.accountDescription.head_office_county = this.accountDescription.registered_office_county;
        this.accountDescription.head_office_postcode = this.accountDescription.registered_office_postcode;

        this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value = this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value
        this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value = this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value


      } else {

        if (this.old_head_office_country == null) {
          this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value = null
          this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value = null

        }
        else {
          this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value = this.old_head_office_country
          this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value = this.old_head_office_country
        }

        this.accountDescription.head_office_address_1 = this.old_head_office_address_1;
        this.accountDescription.head_office_address_2 = this.old_head_office_address_2;
        this.accountDescription.head_office_address_3 = this.old_head_office_address_3;
        this.accountDescription.head_office_city = this.old_head_office_city;
        this.accountDescription.head_office_county = this.old_head_office_county;
        this.accountDescription.head_office_postcode = this.old_head_office_postcode;

        if (this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value != null || this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value != '') {
          this.head_office_country_validation = null

        }

        if (this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value != null || this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value != '') {
          this.registered_office_country_validation = null

        }


      }
    },
    overwriteDataBuildRegisteredOfficeAddressToMasterDB(val) {
      console.log('overwriteDataBuildAddressToMasterDB', val)

      if (val) {
        this.updateSatelliteOfficeAccountDescription.registered_office_address_1 =
          this.accountDescription.registered_office_address_1
        this.updateSatelliteOfficeAccountDescription.registered_office_address_2 =
          this.accountDescription.registered_office_address_2
        this.updateSatelliteOfficeAccountDescription.registered_office_address_3 =
          this.accountDescription.registered_office_address_3
        this.updateSatelliteOfficeAccountDescription.registered_office_city =
          this.accountDescription.registered_office_city
        this.updateSatelliteOfficeAccountDescription.registered_office_county =
          this.accountDescription.registered_office_county
        this.updateSatelliteOfficeAccountDescription.registered_office_postcode =
          this.accountDescription.registered_office_postcode

        this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value =
          this.accountDescription.registered_office_country
        this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value =
          this.accountDescription.registered_office_country
      } else {
        this.updateSatelliteOfficeAccountDescription.registered_office_address_1 =
          this.old_registered_office_address_1_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.registered_office_address_2 =
          this.old_registered_office_address_2_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.registered_office_address_3 =
          this.old_registered_office_address_3_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.registered_office_city =
          this.old_registered_office_city_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.registered_office_county =
          this.old_registered_office_county_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.registered_office_postcode =
          this.old_registered_office_postcode_update_satellite_office

        this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value =
          this.old_registered_office_country_update_satellite_office
        this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value =
          this.old_registered_office_country_update_satellite_office
      }
    },
    overwriteDataBuildHeadOfficeAddressToMasterDB(val) {
      console.log('overwriteDataBuildHeadOfficeAddressToMasterDB', val)

      if (val) {
        this.updateSatelliteOfficeAccountDescription.head_office_address_1 =
          this.accountDescription.head_office_address_1
        this.updateSatelliteOfficeAccountDescription.head_office_address_2 =
          this.accountDescription.head_office_address_2
        this.updateSatelliteOfficeAccountDescription.head_office_address_3 =
          this.accountDescription.head_office_address_3
        this.updateSatelliteOfficeAccountDescription.head_office_city =
          this.accountDescription.head_office_city
        this.updateSatelliteOfficeAccountDescription.head_office_county =
          this.accountDescription.head_office_county
        this.updateSatelliteOfficeAccountDescription.head_office_postcode =
          this.accountDescription.head_office_postcode

        this.$refs.SatelliteOfficeaccountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value =
          this.accountDescription.head_office_country
        this.$refs.SatelliteOfficeaccountEditHeadOfficeCountryRef.$refs.suggestComponent.value =
          this.accountDescription.head_office_country
      } else {
        this.updateSatelliteOfficeAccountDescription.head_office_address_1 =
          this.old_head_office_address_1_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.head_office_address_2 =
          this.old_head_office_address_2_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.head_office_address_3 =
          this.old_head_office_address_3_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.head_office_city =
          this.old_head_office_city_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.head_office_county =
          this.old_head_office_county_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.head_office_postcode =
          this.old_head_office_postcode_update_satellite_office

        this.$refs.SatelliteOfficeaccountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value =
          this.old_head_office_country_update_satellite_office
        this.$refs.SatelliteOfficeaccountEditHeadOfficeCountryRef.$refs.suggestComponent.value =
          this.old_head_office_country_update_satellite_office
      }
    },
    "accounts.websites"(val) {
      if (val) {
        var lastItem = val[val.length - 1];
        if (this.validDomain(lastItem)) {
          this.$store
            .dispatch("accountsManagement/checkWebsiteExists", lastItem)
            .then(res => {
              if (res.data.status == "fail") {
                this.websiteExists = true;
                this.$vs.dialog({
                  color: "primary",
                  title: `Confirm`,
                  text: "This website already exists.",
                  accept: (this.websiteExists = false)
                });
                var index = this.accounts.websites.indexOf(lastItem);
                this.accounts.websites.splice(index, 1);
              } else {
                return;
              }
            })
            .catch(err => {
              if (err.response.status === 401) {
                this.$router.replace("/login");
              }
            });
        } else {
          var index = this.accounts.websites.indexOf(lastItem);
          this.accounts.websites.splice(index, 1);
          return false;
        }
      }
    },
    "accounts.linkedins"(val) {
      if (val) {
        var lastItem = val[val.length - 1];
        if (this.validDomain(lastItem)) {
          this.$store
            .dispatch("accountsManagement/checkLinkedinExists", lastItem)
            .then(res => {
              if (res.data.status == "fail") {
                this.linkedinExists = true;
                this.$vs.dialog({
                  color: "primary",
                  title: `Confirm`,
                  text: "This linkedin already exists.",
                  accept: (this.linkedinExists = false)
                });
                var index = this.accounts.linkedins.indexOf(lastItem);
                this.accounts.linkedins.splice(index, 1);
              } else {
                return;
              }
            })
            .catch(err => {
              if (err.response.status === 401) {
                this.$router.replace("/login");
              }
            });
        } else {
          var index = this.accounts.linkedins.indexOf(lastItem);
          this.accounts.linkedins.splice(index, 1);
          return false;
        }
      }
    },
    'contactDescription.role'(val) {
      this.contactDescription.sub_roles = []

      if (val) {



        if (val.id !== undefined) {
          this.getSubRole(val.id)
        } else {

          if (Object.keys(val).length != 0) {

            console.log("contactDescription.role", val)

            if (typeof val === 'object' && val !== null) {
              val = val[0].role
            }

            this.getSubRoleByName(val)
          }


        }
      }
    },
    currentx: function (val, oldVal) {
      this.unmatch_contacts = this.request_accounts.slice(
        (val - 1) * this.limit,
        val * this.limit
      )

      console.log('currentx', val)

      this.writeMasterDatabaseAndMatch(this.request_accounts[val - 1])
    }
  },

  methods: {
    removeSatelliteOfficeSelectedPhone(phone) {
      this.updateSatelliteOfficeAccountDescription.phone =
        this.updateSatelliteOfficeAccountDescription.phone.filter(item => {
          return item != phone
        })

      this.SatelliteOfficeaddWebsite()

    },
    addSatelliteOfficePhone() {
      let self = this

      self.updateSatelliteOfficeAccountDescription.phone.push({
        phone_code: null,
        phone_no: null,
        phone_type: null
      })

      self.SatelliteOfficeaddWebsite()

    },
    addsubsidiaryPhone() {
      let self = this

      self.subsidiaryAccountDescription.phone.push({
        phone_code: null,
        phone_no: null,
        phone_type: null
      })

      self.subsidiaryaddWebsite()

    },
    submitAccountForm() {
      this.$vs.loading()

      this.correction_fields_array = []

      this.currency_code_validation = null

      this.accountDescription.registered_office_country =
        this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value
      this.accountDescription.registered_office_country =
        this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value

      this.accountDescription.head_office_country =
        this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value
      this.accountDescription.head_office_country =
        this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value

      this.accountDescription.account_user_id = this.user_id
      this.accountDescription.campaign_id = this.$route.params.campaignId
      this.accountDescription.table_id = this.temp_table_id
      this.accountDescription.id = this.temp_table_id
      this.accountDescription.no_of_employees =
        this.accountDescription.employees

      if (this.accountDescription.no_of_employees == '') {
        this.accountDescription.no_of_employees = null
      }

      if (this.accountDescription.revenue == '') {
        this.accountDescription.revenue = null
      }



      this.accountDescription.joinedSicAndDescription =
        this.accounts.joinedSicAndDescription

      this.accountDescription.satellite_office = this.accounts.satellite_office

      this.$validator.validateAll('AddNewAccountForm').then(result => {
        if (result) {
          if (moduleAccountsManagement.autocomplete_selected) {
            this.accountDescription.parent =
              moduleAccountsManagement.autocomplete_selected.id
          }
          if (moduleAccountsManagement.vertical_selected) {
            this.accountDescription.vertical =
              moduleAccountsManagement.vertical_selected.id
          }

          if (moduleAccountsManagement.countries_selected) {
            this.accountDescription.registration_jurisdiction =
              moduleAccountsManagement.countries_selected.id
          }

          this.accountDescription.joinedSicAndDescription = this.accounts.joinedSicAndDescription




          if (moduleAccountsManagement.head_office_country_selected) {
            this.accountDescription.head_office_country =
              moduleAccountsManagement.head_office_country_selected.name
          }

          if (moduleAccountsManagement.registered_office_country_selected) {
            this.accountDescription.registered_office_country =
              moduleAccountsManagement.registered_office_country_selected.name
          }

          if (this.accountDescription.revenue == '') {
            this.accountDescription.revenue = null
          }

          if (
            this.accountDescription.revenue != null &&
            this.accountDescription.currency_code == null
          ) {
            this.currency_code_validation =
              'The currency code field is required'
            this.$vs.loading.close()

            return false
          }


          this.accountDescription.table_id = this.$route.params.requestAccountId






          if (this.accountDescription.matched_account_id == null) {

            this.addRequestedAccountToMasterDB()
          }
          else {

            this.updateRequestedAccountForm()
            this.$vs.loading.close()
          }




          // if form have no errors
        } else {
          this.$vs.loading.close()

        }

        this.$vs.loading.close()
      })
    },
    updateRequestedAccountForm() {
      this.$vs.loading()

      this.accountDescription.registered_office_country =
        this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value
      this.accountDescription.registered_office_country =
        this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value

      this.accountDescription.head_office_country =
        this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value
      this.accountDescription.head_office_country =
        this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value

      if (this.accountDescription.is_sole_trader) {
        this.accountDescription.IsSoleTraderFields = {
          company_name:
            this.accountDescription.company_name,
          head_office_country:
            this.accountDescription.head_office_country
        }

        if (
          this.accountDescription.head_office_country ==
          null ||
          this.accountDescription.head_office_country == ''
        ) {
          this.head_office_country_validation =
            'The Head Office Country field is required'
          this.registered_office_country_validation = null
          return false
        } else {
          this.head_office_country_validation = null
        }
      } else {
        this.accountDescription.IsSoleTraderFields = {
          company_registration_number:
            this.accountDescription
              .company_registration_number,
          registered_office_country:
            this.accountDescription
              .registered_office_country
        }

        if (
          this.accountDescription
            .registered_office_country == null ||
          this.accountDescription
            .registered_office_country == ''
        ) {
          this.registered_office_country_validation =
            'The Registered Office Country field is required'
          this.head_office_country_validation = null
          return false
        } else {
          this.registered_office_country_validation = null
        }
      }
      if (moduleAccountsManagement.autocomplete_selected) {
        this.accountDescription.parent =
          moduleAccountsManagement.autocomplete_selected.id
      }
      if (moduleAccountsManagement.vertical_selected) {
        this.accountDescription.vertical =
          moduleAccountsManagement.vertical_selected.id
      }


      this.accountDescription.phoneWithTypes = []



      if (
        this.accountDescription.revenue != null &&
        this.accountDescription.currency_code == null
      ) {
        this.satellite_office_currency_code_validation =
          'The currency code field is required'
        return false
      }

      this.accountDescription.user_id = this.user_id

      this.accountDescription.campaign_id =
        this.$route.params.campaignId

      this.accountDescription.id = this.accountDescription.matched_account_id



      this.updateMasterDBAccountOnRequestAccount()

    },
    updateMasterDBAccountOnRequestAccount() {
      let self = this
      self.$store
        .dispatch(
          'accountsManagement/updateMasterDBAccountOnRequestAccount',
          self.accountDescription
        )
        .then(res => {
          if (res.data.status == 'fail') {
            self.getPotentialMatchesForRequestAccount()
          } else {


            let result_data = res.data.data
            self.accountDescription.account_id = result_data.id
            self.accountDescription.campaign_id = self.$route.params.campaignId


            self.showUpdateSatelliteOfficePopup = false

            self.MatchedWebsitePopupActive = false

            self.MatchedLinkedInPopupActive = false

            self.MatchedAccountsPopupActive = false

            self.updateSatelliteOfficePopupActive = false

            self.subsidiaryPopupActive = false


            const myElement = document.getElementById('satelliteOfficePopup')

            // Check if the element exists before attempting to modify its style
            if (myElement) {
              // Set the display property to 'none' to hide the element
              myElement.style.display = 'none'
            }


            console.log('self.accountDescription.id', self.accountDescription)






            window.location.reload();







          }
        })
        .catch(err => {
          console.log(err)

          if (err.response.status === 401) {
            self.$router.replace('/login')
          }
        })
    },
    AccountContactRequestComplete() {
      let self = this


      self.submitAccountForm()
      self.submitContactForm()

      let data = {}
      data.user_id = this.user_id
      data.campaign_id = this.$route.params.campaignId
      data.table_id = this.$route.params.requestAccountId
      data.data_administrator_reason_for_request = this.data_administrator_reason_for_request
      data.sales_developer_reason_for_request = this.accountDescription.reason_for_account_request




      this.$store
        .dispatch(
          'contactsManagement/AccountContactRequestComplete',
          data
        )
        .then(res => {
          if (res.data.status == 'success') {



            window.location.href = '/data_build/data_administration_account_request_lists/' + this.$route.params.campaignId;



          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    addRequestedAccountToMasterDB() {
      let self = this




      // console.log("this.accountDescription" , this.accountDescription)
      // return false

      this.$store
        .dispatch(
          'accountsManagement/addRequestedAccountToMasterDB',
          this.accountDescription
        )
        .then(res => {
          if (res.data.status == 'required_correction') {
            this.$vs.dialog({
              color: 'primary',
              title: `Required Correction`,
              text: 'The fields with red title should be corrected. Please update it and submit again'
            })

            self.correction_fields_array = res.data.correction_fields
          } else if (res.data.status == 'company_registration_number_exists') {
            self.submit_match_accounts = res.data.data
            self.MatchedAccountsPopupActive = true
          } else if (
            res.data.status ==
            'company_name_and_registered_office_country_exists'
          ) {
            self.submit_match_accounts = res.data.data
            self.MatchedAccountsPopupActive = true

            console.log(
              'Company Name and Registered Office Country Exists',
              res.data.data
            )
          } else {
            this.$vs.notify({
              color: 'success',
              title: 'Account Added',
              text: 'The account was added successfully'
            })

            window.location.reload();

          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    SatelliteOfficeaddWebsite() {
      if (
        this.updateSatelliteOfficeAccountDescription.web == undefined ||
        this.updateSatelliteOfficeAccountDescription.web == null
      ) {
        this.updateSatelliteOfficeAccountDescription.web = []
      }

      if (
        this.SatelliteOfficeaccounts.web &&
        !this.updateSatelliteOfficeAccountDescription.web.includes(
          this.accounts.web
        )
      )
        this.updateSatelliteOfficeAccountDescription.web.push({
          url: this.SatelliteOfficeaccounts.web
        })
      this.SatelliteOfficeaccounts.web = null
    },
    SatelliteOfficeaddLinkedin() {
      if (
        this.updateSatelliteOfficeAccountDescription.linkedin == undefined ||
        this.updateSatelliteOfficeAccountDescription.linkedin == null
      ) {
        this.updateSatelliteOfficeAccountDescription.linkedin = []
      }
      if (
        this.SatelliteOfficeaccounts.linkedin &&
        !this.updateSatelliteOfficeAccountDescription.linkedin.includes(
          this.SatelliteOfficeaccounts.linkedin
        )
      )
        this.updateSatelliteOfficeAccountDescription.linkedin.push({
          url: this.SatelliteOfficeaccounts.linkedin
        })
      this.SatelliteOfficeaccounts.linkedin = null
    },
    confirmUpdateMDBAccountForm() {


      this.$vs.dialog({
        type: "confirm",
        text: `You are about to associate this account request with "${this.updateSatelliteOfficeAccountDescription.company_name}".  Are you sure this is the same account?`,
        title: `Update & Associate MDB Account`,
        accept: this.updateMDBAccountForm,
        acceptText: "Yes - associate this account"
      });


    },
    updateMDBAccountForm() {
      this.$vs.loading()
      this.updateSatelliteOfficeAccountDescription.registered_office_country =
        this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value
      this.updateSatelliteOfficeAccountDescription.registered_office_country =
        this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value

      this.updateSatelliteOfficeAccountDescription.head_office_country =
        this.$refs.SatelliteOfficeaccountEditHeadOfficeCountryRef.$refs.suggestComponent.value
      this.updateSatelliteOfficeAccountDescription.head_office_country =
        this.$refs.SatelliteOfficeaccountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value

      if (this.updateSatelliteOfficeAccountDescription.is_sole_trader) {
        this.updateSatelliteOfficeAccountDescription.IsSoleTraderFields = {
          company_name:
            this.updateSatelliteOfficeAccountDescription.company_name,
          head_office_country:
            this.updateSatelliteOfficeAccountDescription.head_office_country
        }

        if (
          this.updateSatelliteOfficeAccountDescription.head_office_country ==
          null ||
          this.updateSatelliteOfficeAccountDescription.head_office_country == ''
        ) {
          this.head_office_country_validation =
            'The Head Office Country field is required'
          this.registered_office_country_validation = null
          return false
        } else {
          this.head_office_country_validation = null
        }
      } else {
        this.updateSatelliteOfficeAccountDescription.IsSoleTraderFields = {
          company_registration_number:
            this.updateSatelliteOfficeAccountDescription
              .company_registration_number,
          registered_office_country:
            this.updateSatelliteOfficeAccountDescription
              .registered_office_country
        }

        if (
          this.updateSatelliteOfficeAccountDescription
            .registered_office_country == null ||
          this.updateSatelliteOfficeAccountDescription
            .registered_office_country == ''
        ) {
          this.registered_office_country_validation =
            'The Registered Office Country field is required'
          this.head_office_country_validation = null
          return false
        } else {
          this.registered_office_country_validation = null
        }
      }
      if (moduleAccountsManagement.autocomplete_selected) {
        this.updateSatelliteOfficeAccountDescription.parent =
          moduleAccountsManagement.autocomplete_selected.id
      }
      if (moduleAccountsManagement.vertical_selected) {
        this.updateSatelliteOfficeAccountDescription.vertical =
          moduleAccountsManagement.vertical_selected.id
      }
      if (moduleAccountsManagement.countries_selected) {
        this.updateSatelliteOfficeAccountDescription.registration_jurisdiction =
          moduleAccountsManagement.countries_selected.id
      }

      this.updateSatelliteOfficeAccountDescription.phoneWithTypes = []

      console.log(
        'this.updateSatelliteOfficeAccountDescription.phone',
        this.updateSatelliteOfficeAccountDescription.phone
      )



      this.updateSatelliteOfficeAccountDescription.joinedSicAndDescription =
        this.SatelliteOfficeaccounts.joinedSicAndDescription

      if (
        this.updateSatelliteOfficeAccountDescription.revenue != null &&
        this.updateSatelliteOfficeAccountDescription.currency_code == null
      ) {
        this.satellite_office_currency_code_validation =
          'The currency code field is required'
        return false
      }

      this.updateSatelliteOfficeAccountDescription.user_id = this.user_id

      this.updateSatelliteOfficeAccountDescription.campaign_id =
        this.$route.params.campaignId

      this.updateSatelliteOfficeAccountDescription.table_id = this.temp_table_id

      this.updateMasterDBAccount()

    },
    updateMasterDBAccount() {
      let self = this

      self.updateSatelliteOfficeAccountDescription.table_id = this.$route.params.requestAccountId

      self.$store
        .dispatch(
          'accountsManagement/updateMasterDBAccountOnRequestAccount',
          self.updateSatelliteOfficeAccountDescription
        )
        .then(res => {
          if (res.data.status == 'fail') {
            self.getPotentialMatchesForRequestAccount()
          } else {


            let result_data = res.data.data
            self.accountDescription.account_id = result_data.id
            self.accountDescription.campaign_id = self.$route.params.campaignId


            self.showUpdateSatelliteOfficePopup = false

            self.MatchedWebsitePopupActive = false

            self.MatchedLinkedInPopupActive = false

            self.MatchedAccountsPopupActive = false

            self.updateSatelliteOfficePopupActive = false

            self.subsidiaryPopupActive = false


            const myElement = document.getElementById('satelliteOfficePopup')

            // Check if the element exists before attempting to modify its style
            if (myElement) {
              // Set the display property to 'none' to hide the element
              myElement.style.display = 'none'
            }


            console.log('self.accountDescription.id', self.accountDescription)






            window.location.reload();







          }
        })
        .catch(err => {
          console.log(err)

          if (err.response.status === 401) {
            self.$router.replace('/login')
          }
        })
    },
    SatelliteOfficeaddSiteOffice() {
      this.updateSatelliteOfficeAccountDescription.satellite_office.push({
        counter: ++this.SatelliteOfficeaccounts.main_counter,
        address_1: null,
        address_2: null,
        address_3: null,
        city: null,
        county: null,
        postcode: null,
        country: null,
        phone: null,
        phone_code: null
      })
      // console.log(this.accounts.main_counter);
      // console.log(this.accounts.satellite);
    },
    satelliteOfficeShowRegistrationJurisdiction(countryId) {
      this.$store
        .dispatch('accountsManagement/getCountry', countryId)
        .then(res => {
          this.$refs.SatelliteOfficeEditAccountRegistrationJurisdictionRef.$refs.suggestComponent.input.value =
            res.data.name_1
          this.$refs.SatelliteOfficeEditAccountRegistrationJurisdictionRef.$refs.suggestComponent.value =
            res.data.name_1
        })
        .catch(err => {

          console.error(err)
        })
    },
    SatelliteOfficeaddSicCodes() {



      if (moduleAccountsManagement.sic_codes_selected != undefined && moduleAccountsManagement.sic_codes_selected != null) {
        if (!this.SatelliteOfficeaccounts.joinedSicAndDescription.includes(
          moduleAccountsManagement.sic_codes_selected
        )) {
          this.SatelliteOfficeaccounts.joinedSicAndDescription.push(
            moduleAccountsManagement.sic_codes_selected
          )

        }
      }
      // this.SatelliteOfficeaccounts.joinedSicAndDescription.push(
      //   moduleAccountsManagement.sic_codes_selected
      // )

      this.$refs.SatelliteOfficeSicCodeRefEdit.$refs.suggestComponent.selected =
        null
      this.$refs.SatelliteOfficeSicCodeRefEdit.$refs.suggestComponent.input.value =
        null
      this.$refs.SatelliteOfficeSicCodeRefEdit.$refs.suggestComponent.value =
        null

      this.selected_sic_code = null
    },
    viewPotentialMatchAccountDetails(account) {
      let self = this

      this.updateSatelliteOfficeAccountDescription = {}


      self.$validator.errors.clear()
      self.update_account_and_add_to_campaign_heading =
        'Matched Account Details'
      let updateSatelliteOfficeAccountId = account.id
      this.$store
        .dispatch(
          'accountsManagement/fetchAccount',
          updateSatelliteOfficeAccountId
        )
        .then(res => {
          this.updateSatelliteOfficeAccountDescription = res.data
          this.old_head_office_address_1_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.head_office_address_1
          this.old_head_office_address_2_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.head_office_address_2
          this.old_head_office_address_3_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.head_office_address_3
          this.old_head_office_city_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.head_office_city
          this.old_head_office_county_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.head_office_county
          this.old_head_office_postcode_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.head_office_postcode

          this.$refs.SatelliteOfficeaccountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value =
            this.updateSatelliteOfficeAccountDescription.head_office_country
          this.$refs.SatelliteOfficeaccountEditHeadOfficeCountryRef.$refs.suggestComponent.value =
            this.updateSatelliteOfficeAccountDescription.head_office_country

          this.old_head_office_country_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.head_office_country

          this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value =
            this.updateSatelliteOfficeAccountDescription.registered_office_country
          this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value =
            this.updateSatelliteOfficeAccountDescription.registered_office_country

          this.old_registered_office_address_1_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.registered_office_address_1
          this.old_registered_office_address_2_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.registered_office_address_2
          this.old_registered_office_address_3_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.registered_office_address_3
          this.old_registered_office_city_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.registered_office_city
          this.old_registered_office_county_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.registered_office_county
          this.old_registered_office_postcode_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.registered_office_postcode

          this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value =
            this.updateSatelliteOfficeAccountDescription.registered_office_country
          this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value =
            this.updateSatelliteOfficeAccountDescription.registered_office_country

          this.old_registered_office_country_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.registered_office_country

          this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value =
            this.updateSatelliteOfficeAccountDescription.registered_office_country
          this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value =
            this.updateSatelliteOfficeAccountDescription.registered_office_country

          this.old_company_registration_number =
            this.updateSatelliteOfficeAccountDescription.company_registration_number

          this.updateSatelliteOfficeAccountDescription.phone =
            this.updateSatelliteOfficeAccountDescription.phone.slice(
              0,
              this.telephone_show_no
            )



          if (this.updateSatelliteOfficeAccountDescription.parent) {
            this.satelliteOfficeShowParentName(
              this.updateSatelliteOfficeAccountDescription.parent
            )
          }

          if (
            this.updateSatelliteOfficeAccountDescription
              .registration_jurisdiction
          ) {
            this.satelliteOfficeShowRegistrationJurisdiction(
              this.updateSatelliteOfficeAccountDescription
                .registration_jurisdiction
            )
          }
          if (this.updateSatelliteOfficeAccountDescription.vertical) {
            this.satelliteOfficeShowVertical(
              this.updateSatelliteOfficeAccountDescription.vertical
            )
          }











          this.updateSatelliteOfficeAccountDescription.phone.forEach(function (
            ele
          ) {
            ele.phone_type.forEach(function (phoneTypeEle, index) {
              ele.phone_type = phoneTypeEle.type
                .replaceAll('_', ' ')
                .replace(/\b\w/g, l => l.toUpperCase())
            })
          })

          var self = this

          this.$store
            .dispatch('accountsManagement/getCurrencyCodes')
            .then(response => {
              let result = response.data

              if (self.updateSatelliteOfficeAccountDescription.currency_code) {
                result.forEach(function (ele) {
                  if (
                    ele.id ==
                    self.updateSatelliteOfficeAccountDescription.currency_code
                  ) {
                    self.updateSatelliteOfficeAccountDescription.currency_code =
                      ele.symbol + ' ' + ele.name + ' ' + ele.code
                  }
                })
              }
            })
            .catch(err => {

              console.error(err)
            })

          this.updateSatelliteOfficeAccountDescription.satellite_office =
            this.updateSatelliteOfficeAccountDescription.satellite_office.map(
              ele => {
                let counter = 0
                ele.counter = ++this.SatelliteOfficeaccounts.main_counter
                return ele
              }
            )

          // this.accounts.joinedSicAndDescription = this.updateSatelliteOfficeAccountDescription.sic_code
          this.updateSatelliteOfficeAccountDescription.sic_code.forEach(
            function (e) {
              let mapped = {}
                ; (mapped.id = e.sic_code_detail.id),
                  (mapped.name =
                    e.sic_code_detail.code +
                    ' - ' +
                    e.sic_code_detail.description)
              self.SatelliteOfficeaccounts.joinedSicAndDescription.push(mapped)
            }
          )
        }, this)

      self.showUpdateSatelliteOfficePopup = true

      self.MatchedWebsitePopupActive = false

      self.MatchedLinkedInPopupActive = false

      self.MatchedAccountsPopupActive = false

      self.updateSatelliteOfficePopupActive = true

    },
    satelliteOfficeShowParentName(parentId) {
      this.$store
        .dispatch('accountsManagement/getParent', parentId)
        .then(res => {
          this.$refs.SatelliteOfficeEditAccountParentRef.$refs.suggestComponent.input.value =
            res.data.company_name
          this.$refs.SatelliteOfficeEditAccountParentRef.$refs.suggestComponent.value =
            res.data.company_name
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.parent_name = true
            return
          }
          console.error(err)
        })
    },
    satelliteOfficeShowVertical(verticalId) {
      this.$store
        .dispatch('accountsManagement/getVertical', verticalId)
        .then(res => {
          // this.verticalName = res.data.vertical;
          this.$refs.SatelliteOfficeEditAccountVerticalRef.$refs.suggestComponent.input.value =
            res.data.vertical
          this.$refs.SatelliteOfficeEditAccountVerticalRef.$refs.suggestComponent.value =
            res.data.vertical
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    fetchSDSubStatusByStatusIDAndRoleID(status_id, role_id) {
      let self = this;
      this.$store
        .dispatch("SDSubStatusManagement/fetchSDSubStatusByStatusIDAndRoleID", {
          status_id: status_id,
          role_id: role_id
        })
        .then(res => {
          let result = JSON.parse(res.data);


          self.account_sub_statuses = []
          self.contact_sub_statuses = []

          result.forEach(function (ele) {
            if (ele.level == 'account') {
              self.account_sub_statuses.push(ele)
            }
            if (ele.level == 'contact') {
              self.contact_sub_statuses.push(ele)
            }
          });







        })
        .catch(err => {
          console.error(err);
        });
    },

    updateForm() {





      let self = this
      self.$validator.errors.clear()


      this.accountDescription.registered_office_country = this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value
      this.accountDescription.registered_office_country = this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value

      this.accountDescription.head_office_country = this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value
      this.accountDescription.head_office_country = this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value








      this.$validator.validateAll('UpdateAccount').then(result => {


        console.log('result', this.$validator.errors)

        if (result) {



          this.accountDescription.is_sole_trader = false


          if (this.accountDescription.is_sole_trader) {
            this.accountDescription.IsSoleTraderFields = {
              company_name: this.accountDescription.company_name,
              head_office_country: this.accountDescription.head_office_country
            };

            if (this.accountDescription.head_office_country == null || this.accountDescription.head_office_country == '') {
              this.head_office_country_validation = 'The Head Office Country field is required'
              this.registered_office_country_validation = null
              return false
            } else {
              this.head_office_country_validation = null
            }




          } else {
            this.accountDescription.IsSoleTraderFields = {
              company_registration_number: this.accountDescription
                .company_registration_number,
              registered_office_country: this.accountDescription.registered_office_country
            };


            if (this.accountDescription.registered_office_country == null || this.accountDescription.registered_office_country == '') {
              this.registered_office_country_validation = 'The Registered Office Country field is required'
              this.head_office_country_validation = null
              return false
            } else {
              this.registered_office_country_validation = null
            }



          }
          if (moduleAccountsManagement.autocomplete_selected) {
            this.accountDescription.parent =
              moduleAccountsManagement.autocomplete_selected.id;
          }
          if (moduleAccountsManagement.vertical_selected) {
            this.accountDescription.vertical =
              moduleAccountsManagement.vertical_selected.id;
          }
          if (moduleAccountsManagement.countries_selected) {
            this.accountDescription.registration_jurisdiction =
              moduleAccountsManagement.countries_selected.id;
          }

          this.accountDescription.id = this.$route.params.accountId;

          this.accountDescription.phoneWithTypes = [];
          this.accountDescription.phone.map(phone_ele => {
            phone_ele.phone_type.map(phone_type_ele => {
              if (phone_type_ele.phone_id == phone_ele.id) {
                let mappedPhoneTypes = {};
                mappedPhoneTypes.phone_code = phone_ele.phone_code;
                mappedPhoneTypes.phone_no = phone_ele.phone_no;
                mappedPhoneTypes.phone_type = phone_type_ele.type;
                this.accountDescription.phoneWithTypes.push(mappedPhoneTypes);
              }
            });
          });
          this.accountDescription.phoneWithTypes = _.unionBy(
            this.accountDescription.phoneWithTypes,
            this.accounts.phoneWithTypes,
            "phone_no"
          );

          this.accountDescription.joinedSicAndDescription = this.accounts.joinedSicAndDescription

          if (
            this.accountDescription.revenue != null &&
            this.accountDescription.currency_code == null
          ) {
            this.currency_code_validation =
              "The currency code field is required";
            return false;
          }

          this.accountDescription.user_id = this.user_id
          this.updateAccount();
          // if form have no errors
        } else {
          // form have errors
        }
      });
    },
    updateAccount() {
      this.$store
        .dispatch("accountsManagement/updateAccount", this.accountDescription)
        .then(res => {
          this.$vs.notify({
            color: "success",
            title: "Account",
            text: res.data.message
          });
          this.$router.go(0);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getPhoneTypes() {
      this.$store
        .dispatch("accountsManagement/getPhoneTypes")
        .then(res => {
          this.accounts.phoneTypes = res.data;
          this.accounts.phoneTypes = this.accounts.phoneTypes.filter(
            item => item.name != "Site Switchboard"
          );
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getVerticals(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getVerticals", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.verticals;
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].vertical
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    showParentName(parentId) {
      this.$store
        .dispatch("accountsManagement/getParent", parentId)
        .then(res => {
          this.$refs.EditAccountParentRef.$refs.suggestComponent.input.value = res.data.company_name;
          this.$refs.EditAccountParentRef.$refs.suggestComponent.value = res.data.company_name;
        })
        .catch(err => {

          console.error(err);
        });
    },
    showRegistrationJurisdiction(countryId) {
      this.$store
        .dispatch("accountsManagement/getCountry", countryId)
        .then(res => {
          this.$refs.EditAccountRegistrationJurisdictionRef.$refs.suggestComponent.input.value = res.data.name_1
          this.$refs.EditAccountRegistrationJurisdictionRef.$refs.suggestComponent.value = res.data.name_1
        })
        .catch(err => {

          console.error(err);
        });
    },
    showVertical(verticalId) {
      this.$store
        .dispatch("accountsManagement/getVertical", verticalId)
        .then(res => {
          // this.verticalName = res.data.vertical;
          this.$refs.EditAccountVerticalRef.$refs.suggestComponent.input.value = res.data.vertical;
          this.$refs.EditAccountVerticalRef.$refs.suggestComponent.value = res.data.vertical;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getCountries(inputValue) {

      return this.$store
        .dispatch("accountsManagement/getCountries", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.countries;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].name_1
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    submitFormAnyway() {

      this.addContactsAnyway()

    },
    cancelSubmitFormAnyway() {
      this.MatchedContactsPopupActive = false
    },

    confirmUpdateMDBContact() {

      this.$vs.dialog({
        type: "confirm",
        text: `You are about to associate this contact request with "${this.updateContactDescription.forename + ' ' + this.updateContactDescription.surname}".  Are you sure this is the same contact?`,
        title: `Update & Associate MDB Contact`,
        accept: this.updateContactDescriptionForm,
        acceptText: "Yes - associate this contact"
      });

    },


    updateContactDescriptionForm() {
      this.$vs.loading()

      this.updateContactDescription.user_id = this.user_id

      this.updateContactDescription.campaign_id =
        this.$route.params.campaignId


      this.updateContactDescription.table_id = this.$route.params.requestAccountId




      if (!this.updateContactDescription.new_contact) {

        this.updateRequestContactToMasterDB()
      }



      this.$vs.loading.close()
    },
    updateRequestContactToMasterDB() {
      let self = this


      if (Array.isArray(this.updateContactDescription.role)) {
        this.updateContactDescription.role = this.updateContactDescription.role[0];
      }

      if (Array.isArray(this.updateContactDescription.sub_role)) {
        this.updateContactDescription.sub_role = this.updateContactDescription.sub_role[0];
      }

      if (Array.isArray(this.updateContactDescription.seniority)) {
        this.updateContactDescription.seniority = this.updateContactDescription.seniority[0];
      }

      this.$vs.loading()

      self.$store
        .dispatch(
          'contactsManagement/updateRequestContactToMasterDB',
          self.updateContactDescription
        )
        .then(res => {
          if (res.data.status == 'fail') {
            self.getPotentialContactMatchesForDataBuild()
          } else {


            this.$vs.notify({
              color: 'success',
              title: 'Request Contact',
              text: 'The request has been submitted successfully.',
              time: 2000
            })

            setTimeout(() => {
              window.location.reload()
            }, 2000)








          }
        })
        .catch(err => {
          console.log(err)

          if (err.response.status === 401) {
            self.$router.replace('/login')
          }
        })
    },

    cancelContactDescriptionForm() {
      let self = this

      self.MatchedEmailPopupActive = false

      self.MatchedSocialMediaPopupActive = false

      self.MatchedContactsPopupActive = false

      self.updateContactsDetailsPopupActive = false
      self.$validator.errors.clear()
    },
    validateUpdateContactDescriptionEmailZeroBounce(email) {
      let self = this

      self.$vs.loading();

      this.$store
        .dispatch("contactsManagement/validateEmailZeroBounce", email)
        .then(res => {
          self.email_validate_status = res.data
          self.$vs.loading.close();

          console.log(res)
        })
        .catch(err => {
          console.error(err);
        });




    },
    addUpdateContactDescriptionSocialMedia() {
      this.updateContactDescription.social_medias.push({
        social_media: null,
        summary: null,
        primary: false

      });
    },
    addUpdateContactDescriptionEmail() {
      this.updateContactDescription.emails.push({
        email: null,
        primary: false

      });
    },
    addUpdateContactDescriptionDDI() {
      this.updateContactDescription.ddis.push({
        ddi: null,
        ddi_phone_code: null,
        primary: false

      });
    },
    addUpdateContactDescriptionMobile() {
      this.updateContactDescription.mobiles.push({
        mobile: null,
        mobile_phone_code: null,
        primary: false

      });
    },

    removeSelectedUpdateContactDescriptionSocialMedia(social_media) {
      this.updateContactDescription.social_medias = this.updateContactDescription.social_medias.filter(
        item => {
          return item != social_media;
        }
      );
    },
    removeSelectedUpdateContactDescriptionEmail(email) {
      this.updateContactDescription.emails = this.updateContactDescription.emails.filter(
        item => {
          return item != email;
        }
      );
    },
    removeSelectedUpdateContactDescriptionMobile(mobile) {
      this.updateContactDescription.mobiles = this.updateContactDescription.mobiles.filter(
        item => {
          return item != mobile;
        }
      );
    },
    removeSelectedUpdateContactDescriptionDDI(ddi) {
      this.updateContactDescription.ddis = this.updateContactDescription.ddis.filter(
        item => {
          return item != ddi;
        }
      );
    },

    viewPotentialMatchContactDetails(contact) {


      // return false
      let self = this

      this.updateContactDescription = {}

      self.showUpdateSContactDetailsPopup = true

      // self.$validator.errors.clear()
      self.update_contact_and_add_to_campaign_heading =
        'Matched Contact Details'
      let updateContactDetail = { contact_id: contact.contact_id, account_id: contact.account_id }
      this.$store
        .dispatch(
          'contactsManagement/fetchContact',
          updateContactDetail
        )
        .then(res => {
          this.updateContactDescription = res.data



          //     this.$refs.updateContactCompanyRef.$refs.suggestComponent.input.value =
          //   this.updateContactDescription.company_name
          // this.$refs.updateContactCompanyRef.$refs.suggestComponent.value =
          //   this.updateContactDescription.company_name


          console.log(
            "Update Contact Description",
            self.updateContactDescription
          );


          if (self.updateContactDescription.role) {
            self.updateContactDescription.role.forEach(function (ele) {
              ele.id = ele.uuid;
              return ele;
            });
          }

          if (self.updateContactDescription.sub_role) {
            self.updateContactDescription.sub_role.forEach(function (ele) {
              ele.id = ele.uuid;
              return ele;
            });
          }

          if (self.updateContactDescription.seniority) {
            self.updateContactDescription.seniority.forEach(function (ele) {
              ele.id = ele.uuid;
              return ele;
            });
          }

          if (self.updateContactDescription.job_title) {
            if (Array.isArray(self.updateContactDescription.job_title)) {
              self.updateContactDescription.job_title =
                self.updateContactDescription.job_title[0]["job_title"];
            }

          }

          // self.getSubRole(self.updateContactDescription.role[0].id);






          // this.$refs.SatelliteOfficecontactEditHeadOfficeCountryRef.$refs.suggestComponent.input.value =
          //   this.updateContactDescription.head_office_country
          // this.$refs.SatelliteOfficecontactEditHeadOfficeCountryRef.$refs.suggestComponent.value =
          //   this.updateContactDescription.head_office_country










          self.MatchedEmailPopupActive = false

          self.MatchedSocialMediaPopupActive = false

          self.MatchedContactsPopupActive = false

          self.updateContactsDetailsPopupActive = true
        })

    },
    getAllPhoneCodes() {
      let self = this
      this.$store
        .dispatch("accountsManagement/getAllPhoneCodes")
        .then(response => {
          self.all_phone_codes = response.data
          self.all_phone_codes.forEach(function (ele) {
            if (ele.phone_code) {
              ele.name_with_code = ele.phone_code + ' - ' + ele.name_1
            }
            return ele
          })


        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    validDomain(userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        )
        if (res == null) {
          return false
        }
      }
      return true
    },
    editSubmitForm() {
      // console.log(this.editContactDescription)
      // return false

      let self = this
      if (this.editContactDescription.edit_primary_email) {
        this.editContactDescription.primary_email =
          this.editContactDescription.edit_primary_email
      }
      // if (
      //   self.edit_accounts.length === 0 &&
      //   self.editContactDescription.company_name == null
      // ) {
      //   self.edit_contact_validation = "The Account field is required";
      //   return false;
      // } else {
      //   if (self.edit_accounts.length != 0) {
      //     self.editContactDescription.account_id = self.edit_accounts[0].id;
      //   }
      //   self.updateEditContact();
      // }

      this.$validator.validateAll('popup-edit-form').then(result => {
        // console.log(this.editContactDescription.company_name);
        if (result) {
          if (
            self.edit_accounts.length === 0 &&
            self.editContactDescription.company_name == null
          ) {
            self.edit_contact_validation = 'The Account field is required'
            return false
          } else {
            if (self.edit_accounts.length != 0) {
              self.editContactDescription.account_id = self.edit_accounts[0].id
            }
            self.updateEditContact()
          }

          // if form have no errors
        } else {
          return false
        }
      })
    },
    updateEditContact() {
      if (Array.isArray(this.editContactDescription.role)) {
        this.editContactDescription.role = this.editContactDescription.role[0]
      }

      if (Array.isArray(this.editContactDescription.sub_role)) {
        this.editContactDescription.sub_role =
          this.editContactDescription.sub_role[0]
      }

      if (Array.isArray(this.editContactDescription.seniority)) {
        this.editContactDescription.seniority =
          this.editContactDescription.seniority[0]
      }

      // if (Array.isArray(this.editContactDescription.job_title)) {
      //   this.editContactDescription.job_title = this.editContactDescription.job_title[0];
      // }

      //       console.log("sfsdfsdf" , this.editContactDescription)
      // return false

      if (Object.keys(this.editContacts.satellite_address).length != 0) {
        this.editContactDescription.satellite_office_id =
          this.editContacts.satellite_address.uuid
      } else {
        this.editContactDescription.satellite_office_id = null
      }
      this.$store
        .dispatch(
          'contactsManagement/updateContact',
          this.editContactDescription
        )
        .then(res => {
          if (res.data.status == 'success') {
            this.$refs.EditEmailExistsInDb.gridApi.refreshServerSide({
              purge: true
            })

            this.editContactShowPopup = false
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    editContact() {
      this.viewContactpopupActive = false
      let contactId = this.contactDescription.uuid
      this.editInit(contactId)
      this.editContactShowPopup = true

      // let route = this.$router.resolve("/contacts/edit/" + contactId); // This also works.
      // window.open(route.href, "_blank");

      // this.$router.replace("edit/" + this.contactDescription.id);
      // this.$router.push({ path: `edit/${contactId}` });
    },
    editContactpopup(contact) {
      let contactId = contact.contact_id
      this.editInit(contactId)
      this.editContactShowPopup = true
    },
    viewContactDetails(contactId) {
      this.$store
        .dispatch('contactsManagement/fetchContact', contactId)
        .then(res => {
          this.viewContactDescription = res.data
          this.viewContactpopupActive = true
        })
        .catch(err => {
          console.error(err)
        })
    },
    viewContactpopup(contact) {
      this.viewContactDetails(contact.contact_id)
    },
    closeThisWindow() {
      let self = this
      self.viewContactpopupActive = false
    },
    removeSelectedSocialMedia(social_media) {
      this.contactDescription.social_medias =
        this.contactDescription.social_medias.filter(item => {
          return item != social_media
        })
    },
    removeSelectedEmail(email) {
      this.contactDescription.emails = this.contactDescription.emails.filter(
        item => {
          return item != email
        }
      )
    },
    removeSelectedMobile(mobile) {
      this.contactDescription.mobiles = this.contactDescription.mobiles.filter(
        item => {
          return item != mobile
        }
      )
    },
    removeSelectedDDI(ddi) {
      this.contactDescription.ddis = this.contactDescription.ddis.filter(
        item => {
          return item != ddi
        }
      )
    },
    handleChildEvent() {
      this.satellite_offices = []
      this.accounts = moduleAccountsManagement.state.accounts.datas
      this.contactDescription.account_id = this.accounts[0].id
    },
    searchAccount(inputValue) {
      return this.$store
        .dispatch('accountsManagement/getCompanyOrRegistrationNo', inputValue)
        .then(response => {
          if (response) {
            let data = moduleAccountsManagement.state.company_or_registration_no
            if (data) {
              console.log(data)
              let mappedArray = []
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    ' - ' +
                    data[property].company_registration_number
                })
              }
              return mappedArray
            }
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getSeniority() {
      this.$store
        .dispatch('contactsManagement/getSeniority')
        .then(res => {
          this.contacts.seniorities = res.data
          // console.log(this.contacts.seniorities);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getRoles() {
      this.$store
        .dispatch('contactsManagement/getRoles')
        .then(res => {
          this.contacts.roles = res.data
          // console.log("Roles", this.contacts.roles);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getSubRole(role_id) {
      // alert(role_id)
      // if(!role_id){
      // this.contactDescription.sub_role = null

      // }
      this.$store
        .dispatch('contactsManagement/getSubRoles', role_id)
        .then(res => {
          this.contacts.sub_roles = res.data
        })
        .catch(err => {
          console.error(err)
        })
    },
    getSubRoleByName(role_name) {
      // alert(role_id)
      // if(!role_id){
      // this.contactDescription.sub_role = null

      // }
      this.$store
        .dispatch('contactsManagement/getSubRolesByName', role_name)
        .then(res => {
          this.contacts.sub_roles = res.data
        })
        .catch(err => {
          console.error(err)
        })
    },
    goBack: function () {
      this.$router.push('/data_build/data_administration_account_request_lists/' + this.$route.params.campaignId)
    },
    removeSelectedPhone(selected) {
      this.contacts.joinedPhoneAndTypes =
        this.contacts.joinedPhoneAndTypes.filter(item => {
          return item != selected
        })
    },
    validDomain(userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        )
        if (res == null) {
          return false
        }
      }
      return true
    },

    validateEmailZeroBounce(email) {
      let self = this

      if (email != null && email != '') {
        self.$vs.loading()

        this.$store
          .dispatch('contactsManagement/validateEmailZeroBounce', email)
          .then(res => {
            self.email_validate_status = res.data
            self.$vs.loading.close()

            self.addEmail()

            console.log(res)
          })
          .catch(err => {
            self.$vs.loading.close()

            console.error(err)
          })
      }
    },
    addDDI() {


      this.contactDescription.ddis.push({
        ddi: null,
        ddi_phone_code: null,
        primary: false
      })
    },
    addMobile() {
      this.contactDescription.mobiles.push({
        mobile: null,
        mobile_phone_code: null,
        primary: false
      })
    },
    submitExistingMasterDatabaseContacts() {


      this.selected_existing_master_database_contacts = []

      this.existing_master_database_contacts.forEach((contact) => {
        if (contact.selected) {
          contact.campaign_id = this.$route.params.campaignId
          contact.table_id = this.contactDescription.id
          contact.user_id = this.user_id
          this.selected_existing_master_database_contacts.push(contact)
        }
      })


      console.log(this.selected_existing_master_database_contacts)






      this.$store
        .dispatch(
          'contactsManagement/buildExistingMasterDatabaseContactsToCampaign',
          this.selected_existing_master_database_contacts
        )
        .then(res => {

          if (res.data.status == 'success') {
            this.$vs.notify({
              color: 'success',
              title: 'contact Added',
              text: 'The contact was added successfully'
            })

            this.$router.go(0)
          }


        })
        .catch(err => {
          console.log(err)
        })


      //     let self = this
      //     self.$validator.errors.clear()


      //  self.$validator.validateAll().then(result => {
      //       if (result) {
      //          self.contactDescription.user_id = this.user_id
      //     self.contactDescription.campaign_id = this.$route.params.campaignId
      //     self.contactDescription.table_id = this.temp_table_id
      //     self.contactDescription.id = this.temp_table_id
      //     self.addContactToMasterDBAndMoveToOtherAccount()
      //       } else {
      //          self.$vs.loading.close()

      //       }
      //                 self.$vs.loading.close()

      //     })

    },
    submitContactForm() {


      let self = this
      self.$validator.errors.clear()


      self.$validator.validateAll('AddNewContactForm').then(result => {

        console.log('result', this.$validator.errors)

        if (result) {
          self.contactDescription.user_id = this.user_id
          self.contactDescription.campaign_id = this.$route.params.campaignId
          self.contactDescription.table_id = this.$route.params.requestAccountId






          if (self.contactDescription.add_new_contact_to_this_campaign) {

            self.updateContactDescription = self.contactDescription




            self.updateRequestContactToMasterDB()
          } else if (this.contactDescription.move_contact_to_other_account) {


            this.contactDescription.previous_account_id = self.contactDescription.original_account_id
            self.contactDescription.account_id = this.accountDescription.matched_account_id



            self.updateContactAndMoveToOtherAccount()
          }
          else {


            this.contactDescription.previous_account_id = self.contactDescription.original_account_id
            self.contactDescription.account_id = this.accountDescription.matched_account_id





            self.addContactToMasterDBAndMoveToOtherAccount()

          }


        } else {
          self.$vs.loading.close()

        }
        self.$vs.loading.close()

      })

    },
    updateContactAndMoveToOtherAccount() {

      if (Array.isArray(this.contactDescription.role)) {
        this.contactDescription.role = this.contactDescription.role[0];
      }

      if (Array.isArray(this.contactDescription.sub_role)) {
        this.contactDescription.sub_role = this.contactDescription.sub_role[0];
      }

      if (Array.isArray(this.contactDescription.seniority)) {
        this.contactDescription.seniority = this.contactDescription.seniority[0];
      }



      if (Object.keys(this.contacts.satellite_address).length != 0) {
        this.contactDescription.satellite_office_id = this.contacts.satellite_address.uuid;
      } else {
        this.contactDescription.satellite_office_id = null;
      }

      this.contactDescription.table_id = this.$route.params.requestAccountId





      this.$vs.loading()


      this.$store
        .dispatch("contactsManagement/updateContactAndMoveToOtherAccount", this.contactDescription)
        .then(res => {
          if (res.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Request Contact",
              text: "The request has been submitted successfully."
            });
            window.location.reload();




          }
        })
        .catch(err => {
          console.error(err);
        });
    },

    addContactToMasterDBAndMoveToOtherAccount() {






      if (Array.isArray(this.contactDescription.role)) {
        this.contactDescription.role = this.contactDescription.role[0];
      }

      if (Array.isArray(this.contactDescription.sub_role)) {
        this.contactDescription.sub_role = this.contactDescription.sub_role[0];
      }

      if (Array.isArray(this.contactDescription.seniority)) {
        this.contactDescription.seniority = this.contactDescription.seniority[0];
      }



      if (Object.keys(this.contacts.satellite_address).length != 0) {
        this.contactDescription.satellite_office_id = this.contacts.satellite_address.uuid;
      } else {
        this.contactDescription.satellite_office_id = null;
      }

      this.contactDescription.table_id = this.$route.params.requestAccountId










      this.$store
        .dispatch("contactsManagement/addContactToMasterDBAndMoveToOtherAccount", this.contactDescription)
        .then(res => {
          if (res.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Contact",
              text: "The contact was update successfully"
            });
            window.location.reload();




          }
        })
        .catch(err => {
          console.error(err);
        });
    },

    accountRebuildComplete() {
      let self = this
      self.contactDescription.user_id = this.user_id
      self.contactDescription.campaign_id = this.$route.params.campaignId
      self.contactDescription.table_id = this.temp_table_id
      self.contactDescription.id = this.temp_table_id
      self.contactDescription.account_id = this.$route.params.accountId
      self.contactDescription.new_account_status = this.selected_status
      self.contactDescription.new_account_sub_status = this.selected_account_sub_status
      self.contactDescription.new_status_notes = this.selected_status_notes


      console.log("CONTACT DESCR", this.contactDescription)

      this.$store
        .dispatch(
          'contactsManagement/accountRebuildComplete',
          self.contactDescription
        )
        .then(res => {

          if (res.data.status == 'success') {


            this.$router.push(
              '/data_build/data_administration_account_rebuild/' +
              this.$route.params.campaignId
            )
          }


        })
        .catch(err => {
          console.log(err)
        })

    },




    acceptAlert() {
      this.addNewcontactsPopUp = true
    },
    writeMasterDatabaseAndMatch(data) {


      console.log("DATA TO BUILD CONTACT", data)

      this.correction_fields_array = []

      this.$validator.errors.clear()
      this.isNewcontact = 'Y'
      this.add_or_update_title = 'Please update the field and submit'

      this.contactDescription = data


      this.contactDescription.id = data.uuid
      this.temp_table_id = data.uuid




      this.contactDescription.emails = []
      this.contactDescription.social_medias = []
      // this.contactDescription.mobiles = []
      // this.contactDescription.ddis = []



      console.log("CONTACT DESCR", this.contactDescription)




      this.addNewcontactsPopUp = true
    },

    forceRerender() {
      this.componentKey += 1
    },
    getCampaignDescription() {
      const campaignId = this.$route.params.campaignId
      this.$store
        .dispatch('campaignsManagement/fetchCampaign', campaignId)
        .then(res => {
          this.campaignDescription = res.data
        })
        .catch(err => {

          console.error(err)
        })
    },




    // checkDuplicateExists() {
    //   let self = this;
    //   self.paginate.campaignId = self.campaignId;
    //   axios
    //     .post(
    //       this.$base_url + "/api/contacts/deduplicate_csv_contacts_data",
    //       self.paginate
    //     )
    //     .then(response => {
    //       let result = JSON.parse(response.data);

    //       if (result.length == 0) {

    //         self.$router
    //           .push(
    //             "/contacts/optionsAfterImportcontactToCampaign/" +
    //             self.campaignId
    //           )
    //           .catch(() => { });
    //           this.$vs.loading.close();

    //       } else {
    //         this.deduplicateOldNewCSV();
    //       }
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },
    updateOtherFieldDataToMasterDb() {
      let self = this

      self.$vs.dialog({
        color: 'primary',
        title: `Import None Core Fields`,
        text: 'You are about to import non-core fields to the database.  After you click accept this process will start.  You will receive an email once this process has completed. ',
        accept: this.acceptAlert
      })
    },
    acceptAlert() {
      let self = this
      let data = {}
      data.campaign_id = this.campaignId
      axios
        .post(
          this.$base_url +
          '/api/contacts/update_other_field_to_masterdb_from_csv_table',
          data
        )
        .then(response => {
          if (response.data.status == 'success') {
            self.sendCompletedEmail()

            console.log('Updated other field data to master db')
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    sendCompletedEmail() {
      let self = this
      let data = {}
      data.user_id = self.user_id
      data.message = 'Import None Core Fields has been completed.'
      data.subject = 'Import None Core Fields'
      axios
        .post(self.$base_url + '/api/contacts/send_completed_email', data)
        .then(response => {
          if (response.data.status == 'success') {
            self.$vs.notify({
              color: 'success',
              title: 'Import None Core Fields',
              text: 'The email has been sent'
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    deduplicateOldNewCSV() {
      let data = {}
      data.campaignId = this.campaignId
      axios
        .post(
          this.$base_url + '/api/contacts/deduplicate_old_new_csv_contact_data',
          data
        )
        .then(response => {
          if (response.data.status == 'success') {
            this.$router.replace(
              '/contacts/deduplicateOldAndNewcontactCSVData/' + this.campaignId
            )
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    ucFirstAllWords(str) {
      var pieces = str.split(' ')
      for (var i = 0; i < pieces.length; i++) {
        var j = pieces[i].charAt(0).toUpperCase()
        pieces[i] = j + pieces[i].substr(1)
      }
      return pieces.join(' ')
    },
    formatUploadedHeader(s) {
      if (typeof s !== 'string') return ''
      if (s.startsWith('ml_')) return ''
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("slave", " ");
      // s = s.replace("ml", " ");
      return s
    },
    // unmatchedIndividualBuildData () {
    //   let self = this
    //   this.$vs.loading()
    //   let data = {}
    //   data.campaignId = this.campaignId
    //   data.user_id = this.user_id
    //   axios
    //     .post(
    //       this.$base_url +
    //         '/api/contacts/get_accounts_that_have_no_contacts',
    //       data
    //     )
    //     .then(response => {
    //       let response_data = JSON.parse(response.data)


    //       console.log("RESPSSS" , response_data.rows)

    //       if( response_data.rows.length == 0 ){
    //         self.$vs.notify({
    //           color: 'success',
    //           title: 'No Build Contacts',
    //           text: 'There are no build contacts available.'
    //         })

    //         self.$router.push(
    //           '/data_build/contacts_data_administration_campaigns'
    //         )

    //         return false
    //       }

    //       self.unmatch_contacts = response_data.rows.slice(
    //         (self.currentx - 1) * self.limit,
    //         self.currentx * self.limit
    //       )

    //       self.request_accounts = response_data.rows

    //       self.request_accounts = self.request_accounts.map(el => {
    //         let resultobj = {}
    //         Object.entries(el).map(([key, val]) => {
    //           resultobj[
    //             key.split(' ').join('_').replace(/\W+/g, '').toLowerCase()
    //           ] = val
    //           return resultobj
    //         })
    //         return resultobj
    //       })

    //       self.writeMasterDatabaseAndMatch(self.request_accounts[0])

    //       let total = response_data.total_pages
    //       self.all_total = total


    //       // this.table = response_data.campaign_table_data[0]['table_name'];
    //       self.$vs.loading.close()
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // },

    requestIndividualAccountById() {
      let data = {}
      data.campaign_id = this.campaignId
      data.user_id = this.user_id
      data.table_id = this.$route.params.requestAccountId
      axios
        .post(
          this.$base_url +
          '/api/accounts/request_individual_account_by_id',
          data
        )
        .then(response => {
          let response_data = JSON.parse(response.data)



          if (response_data.matched_account_id != null) {

            let accountId = response_data.matched_account_id
            this.$store
              .dispatch("accountsManagement/fetchAccount", accountId)
              .then(res => {
                this.accountDescription = res.data;
                this.accountDescription.matched_account_id = accountId




                this.accountDescription.reason_for_account_request = response_data.reason_for_account_request



                this.accountDescription.IsSoleTraderFields = {};
                this.old_head_office_address_1 = this.accountDescription.head_office_address_1;
                this.old_head_office_address_2 = this.accountDescription.head_office_address_2;
                this.old_head_office_address_3 = this.accountDescription.head_office_address_3;
                this.old_head_office_city = this.accountDescription.head_office_city;
                this.old_head_office_county = this.accountDescription.head_office_county;
                this.old_head_office_postcode = this.accountDescription.head_office_postcode;


                this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value = this.accountDescription.head_office_country;
                this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value = this.accountDescription.head_office_country;
                this.old_head_office_country = this.accountDescription.head_office_country;


                this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value = this.accountDescription.registered_office_country;
                this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value = this.accountDescription.registered_office_country;


                this.old_company_registration_number = this.accountDescription.company_registration_number;


                this.accountDescription.phone.forEach(function (
                  ele
                ) {
                  ele.phone_type.forEach(function (phoneTypeEle, index) {
                    ele.phone_type = phoneTypeEle.type
                      .replaceAll('_', ' ')
                      .replace(/\b\w/g, l => l.toUpperCase())
                  })
                })


                if (this.accountDescription.parent) {
                  this.showParentName(this.accountDescription.parent);
                }




                if (this.accountDescription.registration_jurisdiction) {
                  this.showRegistrationJurisdiction(
                    this.accountDescription.registration_jurisdiction
                  );
                }
                if (this.accountDescription.vertical) {
                  this.showVertical(this.accountDescription.vertical);
                }


                this.accountDescription.employees = this.accountDescription.no_of_employees



                this.$store
                  .dispatch("accountsManagement/getCurrencyCodes")
                  .then(response => {
                    let result = response.data;



                    if (this.accountDescription.currency_code) {
                      result.forEach(function (ele) {
                        if (ele.id == this.accountDescription.currency_code) {
                          this.accountDescription.currency_code = ele.code
                        }
                      }, this);
                    }
                  })
                  .catch(err => {

                    console.error(err);
                  });




                console.log("ACCOUNT SATELLITE OFFICE", this.accounts.satellite_office)

                console.log("accountDescription SATELLITE OFFICE", this.accountDescription.satellite_office)



                if (this.accountDescription.satellite_office.length < 0) {

                  this.accounts.satellite_office = this.accountDescription.satellite_office.map(
                    ele => {
                      let counter = 0;
                      ele.counter = ++this.accounts.main_counter;
                      return ele;
                    }
                  );

                }
                else {
                  this.accounts.satellite_office = this.accountDescription.satellite_office
                }







                this.accountDescription.sic_code.forEach(function (e) {
                  let mapped = {}
                  mapped.id = e.sic_code_detail.id,
                    mapped.name = e.sic_code_detail.code + ' - ' + e.sic_code_detail.description
                  this.accounts.joinedSicAndDescription.push(mapped)
                }, this)




                this.getPotentialMatchesForRequestAccount()


              })
              .catch(err => {

                console.error(err);
              });










            let contact_details = response_data['contact_details']

            if (contact_details == undefined) {
              this.showContactForm = false
              return false
            }



            if (contact_details.move_contact_to_other_account) {




              if (contact_details.matched_contact_id != null) {
                let ContactDetail = { contact_id: contact_details.matched_contact_id, account_id: contact_details.move_contact_original_account_id }



                this.$store
                  .dispatch(
                    'contactsManagement/fetchContact',
                    ContactDetail
                  )
                  .then(res => {

                    let res_data = res.data
                    if (res_data) {

                      this.contactDescription = res.data


                      this.contactDescription.move_contact_to_other_account = true
                      this.contactDescription.original_account_id = contact_details.move_contact_original_account_id
                      this.contactDescription.matched_contact_id = contact_details.matched_contact_id



                      if (this.contactDescription.role) {
                        this.contactDescription.role.forEach(function (ele) {
                          ele.id = ele.uuid;
                          return ele;
                        });
                      }

                      if (this.contactDescription.sub_role) {
                        this.contactDescription.sub_role.forEach(function (ele) {
                          ele.id = ele.uuid;
                          return ele;
                        });
                      }

                      if (this.contactDescription.seniority) {
                        this.contactDescription.seniority.forEach(function (ele) {
                          ele.id = ele.uuid;
                          return ele;
                        });
                      }



                      if (this.contactDescription.job_title) {
                        if (Array.isArray(this.contactDescription.job_title)) {
                          this.contactDescription.job_title =
                            this.contactDescription.job_title[0]["job_title"];
                        }

                      }

                      this.getPotentialContactMatchesForDataBuild()


                    }



                  })
              }




            }


            else if (contact_details.add_new_contact_to_this_campaign) {


              if (contact_details.matched_contact_id != null) {
                let ContactDetail = { contact_id: contact_details.matched_contact_id, account_id: accountId }
                this.$store
                  .dispatch(
                    'contactsManagement/fetchContact',
                    ContactDetail
                  )
                  .then(res => {

                    let res_data = res.data
                    if (res_data) {

                      this.contactDescription = res.data
                      this.contactDescription.add_new_contact_to_this_campaign = true
                      this.contactDescription.matched_contact_id = contact_details.matched_contact_id



                      if (this.contactDescription.role) {
                        this.contactDescription.role.forEach(function (ele) {
                          ele.id = ele.uuid;
                          return ele;
                        });
                      }

                      if (this.contactDescription.sub_role) {
                        this.contactDescription.sub_role.forEach(function (ele) {
                          ele.id = ele.uuid;
                          return ele;
                        });
                      }

                      if (this.contactDescription.seniority) {
                        this.contactDescription.seniority.forEach(function (ele) {
                          ele.id = ele.uuid;
                          return ele;
                        });
                      }



                      if (this.contactDescription.job_title) {
                        if (Array.isArray(this.contactDescription.job_title)) {
                          this.contactDescription.job_title =
                            this.contactDescription.job_title[0]["job_title"];
                        }

                      }

                      this.getPotentialContactMatchesForDataBuild()


                    }



                  })



              }


            }
            else {




              let contact_details = response_data['contact_details']




              if (contact_details.matched_contact_id != null) {






                let ContactDetail = { contact_id: contact_details.matched_contact_id, account_id: contact_details.move_contact_original_account_id }
                this.$store
                  .dispatch(
                    'contactsManagement/fetchContact',
                    ContactDetail
                  )
                  .then(res => {

                    let res_data = res.data
                    if (res_data) {

                      this.contactDescription = res.data
                      this.contactDescription.add_new_contact_to_this_campaign = true
                      this.contactDescription.matched_contact_id = contact_details.matched_contact_id






                      if (this.contactDescription.role) {
                        this.contactDescription.role.forEach(function (ele) {
                          ele.id = ele.uuid;
                          return ele;
                        });
                      }

                      if (this.contactDescription.sub_role) {
                        this.contactDescription.sub_role.forEach(function (ele) {
                          ele.id = ele.uuid;
                          return ele;
                        });
                      }

                      if (this.contactDescription.seniority) {
                        this.contactDescription.seniority.forEach(function (ele) {
                          ele.id = ele.uuid;
                          return ele;
                        });
                      }



                      if (this.contactDescription.job_title) {
                        if (Array.isArray(this.contactDescription.job_title)) {
                          this.contactDescription.job_title =
                            this.contactDescription.job_title[0]["job_title"];
                        }

                      }

                      this.getPotentialContactMatchesForDataBuild()


                    }



                  })







              } else {



                this.contactDescription = contact_details





                if (this.contactDescription.job_title) {
                  if (Array.isArray(this.contactDescription.job_title)) {
                    this.contactDescription.job_title =
                      this.contactDescription.job_title[0]["job_title"];
                  }

                }
              }

            }





            this.getPotentialContactMatchesForDataBuild()





          } else {







            this.accountDescription = response_data

            this.accountDescription.matched_account_id = null


            this.accountDescription.IsSoleTraderFields = {};
            this.old_head_office_address_1 = this.accountDescription.head_office_address_1;
            this.old_head_office_address_2 = this.accountDescription.head_office_address_2;
            this.old_head_office_address_3 = this.accountDescription.head_office_address_3;
            this.old_head_office_city = this.accountDescription.head_office_city;
            this.old_head_office_county = this.accountDescription.head_office_county;
            this.old_head_office_postcode = this.accountDescription.head_office_postcode;


            this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value = this.accountDescription.head_office_country;
            this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value = this.accountDescription.head_office_country;
            this.old_head_office_country = this.accountDescription.head_office_country;


            this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value = this.accountDescription.registered_office_country;
            this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value = this.accountDescription.registered_office_country;


            this.old_company_registration_number = this.accountDescription.company_registration_number;


            if (this.accountDescription.satellite_office.length < 0) {

              this.accounts.satellite_office = this.accountDescription.satellite_office.map(
                ele => {
                  let counter = 0;
                  ele.counter = ++this.accounts.main_counter;
                  return ele;
                }
              );

            }
            else {
              this.accounts.satellite_office = this.accountDescription.satellite_office
            }







            if (this.accountDescription.registration_jurisdiction) {
              this.showRegistrationJurisdiction(
                this.accountDescription.registration_jurisdiction
              );
            }
            if (this.accountDescription.vertical) {
              this.showVertical(this.accountDescription.vertical);
            }

            this.$store
              .dispatch("accountsManagement/getCurrencyCodes")
              .then(response => {
                let result = response.data;

                if (this.accountDescription.currency_code) {
                  result.forEach(function (ele) {
                    if (ele.id == this.accountDescription.currency_code) {
                      this.accountDescription.currency_code = ele.code
                    }
                  }, this);
                }






                this.accountDescription.sic_code.forEach(function (e) {
                  let mapped = {}
                  mapped.id = e.sic_code_detail.id,
                    mapped.name = e.sic_code_detail.code + ' - ' + e.sic_code_detail.description
                  this.accounts.joinedSicAndDescription.push(mapped)
                }, this)





                this.getPotentialMatchesForRequestAccount()


              })
              .catch(err => {
                console.log(err);
                return;

              });



            let contact_details = response_data['contact_details']




            if (contact_details == undefined) {
              this.showContactForm = false
              return false
            } else {



              if (contact_details.move_contact_to_other_account) {

                if (contact_details.matched_contact_id != null) {
                  let ContactDetail = { contact_id: contact_details.matched_contact_id, account_id: contact_details.move_contact_original_account_id }



                  this.$store
                    .dispatch(
                      'contactsManagement/fetchContact',
                      ContactDetail
                    )
                    .then(res => {

                      let res_data = res.data
                      if (res_data) {

                        this.contactDescription = res.data
                        this.contactDescription.matched_contact_id = contact_details.matched_contact_id



                        if (this.contactDescription.role) {
                          this.contactDescription.role.forEach(function (ele) {
                            ele.id = ele.uuid;
                            return ele;
                          });
                        }

                        if (this.contactDescription.sub_role) {
                          this.contactDescription.sub_role.forEach(function (ele) {
                            ele.id = ele.uuid;
                            return ele;
                          });
                        }

                        if (this.contactDescription.seniority) {
                          this.contactDescription.seniority.forEach(function (ele) {
                            ele.id = ele.uuid;
                            return ele;
                          });
                        }



                        if (this.contactDescription.job_title) {
                          if (Array.isArray(this.contactDescription.job_title)) {
                            this.contactDescription.job_title =
                              this.contactDescription.job_title[0]["job_title"];
                          }

                        }

                        this.getPotentialContactMatchesForDataBuild()


                      }



                    })
                }



              } else {


                if (contact_details.matched_contact_id != null) {



                  let ContactDetail = { contact_id: contact_details.matched_contact_id, account_id: contact_details.move_contact_original_account_id }
                  this.$store
                    .dispatch(
                      'contactsManagement/fetchContact',
                      ContactDetail
                    )
                    .then(res => {

                      let res_data = res.data
                      if (res_data) {

                        this.contactDescription = res.data
                        this.contactDescription.add_new_contact_to_this_campaign = true
                        this.contactDescription.matched_contact_id = contact_details.matched_contact_id



                        if (this.contactDescription.role) {
                          this.contactDescription.role.forEach(function (ele) {
                            ele.id = ele.uuid;
                            return ele;
                          });
                        }

                        if (this.contactDescription.sub_role) {
                          this.contactDescription.sub_role.forEach(function (ele) {
                            ele.id = ele.uuid;
                            return ele;
                          });
                        }

                        if (this.contactDescription.seniority) {
                          this.contactDescription.seniority.forEach(function (ele) {
                            ele.id = ele.uuid;
                            return ele;
                          });
                        }



                        if (this.contactDescription.job_title) {
                          if (Array.isArray(this.contactDescription.job_title)) {
                            this.contactDescription.job_title =
                              this.contactDescription.job_title[0]["job_title"];
                          }

                        }

                        this.getPotentialContactMatchesForDataBuild()


                      }



                    })







                } else {




                  this.contactDescription = contact_details



                  if (this.contactDescription.role) {
                    this.contactDescription.role.forEach(function (ele) {
                      ele.id = ele.uuid;
                      return ele;
                    });
                  }

                  if (this.contactDescription.sub_role) {
                    this.contactDescription.sub_role.forEach(function (ele) {
                      ele.id = ele.uuid;
                      return ele;
                    });
                  }

                  if (this.contactDescription.seniority) {
                    this.contactDescription.seniority.forEach(function (ele) {
                      ele.id = ele.uuid;
                      return ele;
                    });
                  }



                  if (this.contactDescription.job_title) {
                    if (Array.isArray(this.contactDescription.job_title)) {
                      this.contactDescription.job_title =
                        this.contactDescription.job_title[0]["job_title"];
                    }

                  }

                }



              }


              this.getPotentialContactMatchesForDataBuild()



            }







          }















        })
        .catch(error => {
          console.log(error)
        })







    },
    removeSelectedWeb(url) {
      this.accountDescription.web = this.accountDescription.web.filter(item => {
        return item != url;
      });
    },
    removeSelectedLinkedin(url) {
      this.accountDescription.linkedin = this.accountDescription.linkedin.filter(
        item => {
          return item != url;
        }
      );
    },
    removeSelectedPhone(phone) {
      this.accountDescription.phone = this.accountDescription.phone.filter(
        item => {
          return item != phone;
        }
      );
      this.accountDescription.phone = this.accountDescription.phone;
    },
    removeSelectedSicCode(sic_code) {
      this.accountDescription.sic_code = this.accountDescription.sic_code.filter(
        item => {
          return item != sic_code;
        }
      );
      this.accountDescription.phone = this.accountDescription.phone;
    },
    removeNewSelectedSicCode(selected) {
      this.accounts.joinedSicAndDescription = this.accounts.joinedSicAndDescription.filter(
        item => {
          return item != selected;
        }
      );
    },
    removeNewSelectedPhone(selected) {
      this.accounts.joinedPhoneAndTypes = this.accounts.joinedPhoneAndTypes.filter(
        item => {
          return item != selected;
        }
      );
    },
    validDomain(userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        )
        if (res == null) {
          return false
        }
      }
      return true
    },

    addEmail() {
      if (
        this.contactDescription.email == undefined ||
        this.contactDescription.email == null
      ) {
        this.contactDescription.email = []
      }

      this.getMatchedEmails(this.contactDescription.email)
    },
    AddEmailAnyWay() {



      if (
        !this.contactDescription.emails.includes(this.contactDescription.email)
      ) {
        this.contactDescription.emails.push({
          email: this.contactDescription.email,
          primary: false
        })
      }

      this.contactDescription.email = null
      this.MatchedEmailPopupActive = false


    },
    CancelEmailPopup() {
      this.contactDescription.email = null
      this.MatchedEmailPopupActive = false
    },
    addSocialMedia() {
      if (
        this.contactDescription.social_media == undefined ||
        this.contactDescription.social_media == null
      ) {
        this.contactDescription.social_media = []
      }

      this.getMatchedSocialMedias(this.contactDescription.social_media, this.contactDescription.summary)
    },
    AddSocialMediaAnyWay() {


      if (this.contactDescription.summary == undefined) {
        this.contactDescription.summary = ''
      }


      console.log("ADDING ANY WAY", this.contactDescription.social_media, this.contactDescription.summary)



      if (
        !this.contactDescription.social_medias.includes(this.contactDescription.social_media)
      ) {
        this.contactDescription.social_medias.push({
          social_media: this.contactDescription.social_media,
          summary: this.contactDescription.summary,
          primary: false
        })
      }

      this.contactDescription.social_media = null
      this.contactDescription.summary = null
      this.MatchedSocialMediaPopupActive = false
    },
    CancelSocialMediaPopup() {
      this.contactDescription.social_media = null
      this.MatchedSocialMediaPopupActive = false
    },



    addContactsAnyway() {


      let self = this

      if (Array.isArray(this.contactDescription.role)) {
        this.contactDescription.role = this.contactDescription.role[0]
      }

      if (Array.isArray(this.contactDescription.sub_role)) {
        this.contactDescription.sub_role = this.contactDescription.sub_role[0]
      }

      if (Array.isArray(this.contactDescription.seniority)) {
        this.contactDescription.seniority = this.contactDescription.seniority[0]
      }

      this.$store
        .dispatch(
          'contactsManagement/buildcontactAndAddToCampaignAnyway',
          this.contactDescription
        )
        .then(res => {
          if (res.data.status == 'required_correction') {
            this.$vs.dialog({
              color: 'primary',
              title: `Required Correction`,
              text: 'The fields with red title should be corrected. Please update it and submit again'
            })

            self.correction_fields_array = res.data.correction_fields
          } else if (
            res.data.status ==
            'company_name_and_forename_surname_job_title_exists'
          ) {
            self.submit_match_contacts = res.data.data
            self.MatchedContactsPopupActive = true

            console.log(
              'Company Name and Registered Office Country Exists',
              res.data.data
            )
          } else {
            this.$vs.notify({
              color: 'success',
              title: 'contact Added',
              text: 'The contact was added successfully'
            })

            this.$router.go(0)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    addSicCodes() {
      // if (
      //   this.accounts.sic_code &&
      //   this.accounts.sic_code_description &&
      //   !this.accounts.joinedSicAndDescription.includes(
      //     this.accounts.sic_code + " - " + this.accounts.sic_code_description
      //   )
      // )
      //   this.accounts.joinedSicAndDescription.push(
      //     this.accounts.sic_code + " - " + this.accounts.sic_code_description
      //   );
      // let mappedSic = {};
      // mappedSic.code = this.accounts.sic_code;
      // mappedSic.description = this.accounts.sic_code_description;


      this.accounts.joinedSicAndDescription.push(
        moduleAccountsManagement.sic_codes_selected
      );








      // console.log(moduleAccountsManagement.sic_codes_selected)
      // this.accounts.sicWithDescription.push(moduleAccountsManagement.sic_codes_selected);

      this.$refs.SicCodeRefEdit.$refs.suggestComponent.selected = null
      this.$refs.SicCodeRefEdit.$refs.suggestComponent.input.value = null
      this.$refs.SicCodeRefEdit.$refs.suggestComponent.value = null

      this.selected_sic_code = null
    },
    addSiteOffice() {
      this.accounts.satellite_office.push({
        counter: ++this.accounts.main_counter,
        address_1: null,
        address_2: null,
        address_3: null,
        city: null,
        county: null,
        postcode: null,
        phone: null,
        phone_code: null
      })

      // console.log(this.accounts.satellite);
    },
    addPhone() {
      let self = this

      self.accountDescription.phone.push({
        phone_code: null,
        phone_no: null,
        phone_type: null
      })

      self.addWebsite()

    },
    addPhoneNumbers() {
      if (
        this.accounts.phone_code &&
        this.accounts.phone &&
        this.accounts.phoneType &&
        !this.accounts.joinedPhoneAndTypes.includes(
          this.accounts.phoneType.name + " : " + this.accounts.phone_code.phone_code + " - " + this.accounts.phone
        )
      )
        this.accounts.joinedPhoneAndTypes.push(
          this.accounts.phoneType.name + " : " + this.accounts.phone_code.phone_code + " - " + this.accounts.phone
        );
      let mappedPhoneTypes = {};
      mappedPhoneTypes.phone_no = this.accounts.phone;
      mappedPhoneTypes.phone_type = this.accounts.phoneType.slug;
      mappedPhoneTypes.phone_code = this.accounts.phone_code.phone_code;

      this.accounts.phoneWithTypes.push(mappedPhoneTypes);
      this.accounts.phone = null;
      this.accounts.phone_code = null;
      this.accounts.phoneType = null;
    },
    getSicCodes(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getSicCodes", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.sic_codes;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].code + ' - ' + data[property].description
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    addWebsite() {
      if (
        this.accountDescription.web == undefined ||
        this.accountDescription.web == null
      ) {
        this.accountDescription.web = []
      }

      this.getMatchedWebsites(this.accounts.web)
    },
    AddWebsiteAnyWay() {
      if (
        this.accounts.web &&
        !this.accountDescription.web.includes(this.accounts.web)
      )
        this.accountDescription.web.push({ url: this.accounts.web })
      this.accounts.web = null
      this.MatchedWebsitePopupActive = false
    },
    CancelWebsitePopup() {
      this.accounts.web = null
      this.MatchedWebsitePopupActive = false
    },
    addLinkedin() {
      if (
        this.accountDescription.linkedin == undefined ||
        this.accountDescription.linkedin == null
      ) {
        this.accountDescription.linkedin = []
      }
      this.getMatchedLinkedIn(this.accounts.linkedin)
    },
    AddLinkedInAnyWay() {
      if (
        this.accounts.linkedin &&
        !this.accountDescription.linkedin.includes(this.accounts.linkedin)
      )
        this.accountDescription.linkedin.push({ url: this.accounts.linkedin })
      this.accounts.linkedin = null

      this.MatchedLinkedInPopupActive = false
    },
    CancelLinkedInPopup() {
      this.accounts.linkedin = null
      this.MatchedLinkedInPopupActive = false
    },
    getMatchedWebsites(web) {
      let self = this

      if (web != null && web != '') {
        web = web.trim()
      }

      self.matched_websites = []
      let data = {}
      data.website = web

      this.$store
        .dispatch('accountsManagement/getMatchedWebsites', data)
        .then(res => {
          if (res.data.length != 0) {
            self.matched_websites = res.data
            self.MatchedWebsitePopupActive = true
          } else {
            self.AddWebsiteAnyWay()
          }

          console.log('MATCHED WEBSITES', self.matched_websites)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getMatchedLinkedIn(linkedin) {
      let self = this
      self.matched_linkedins = []
      let data = {}

      if (linkedin != null && linkedin != '') {
        linkedin = linkedin.trim()
      }

      data.linkedin = linkedin

      this.$store
        .dispatch('accountsManagement/getMatchedLinkedIn', data)
        .then(res => {
          if (res.data.length != 0) {
            self.matched_linkedins = res.data
            self.MatchedLinkedInPopupActive = true
          } else {
            self.AddLinkedInAnyWay()
          }
          console.log('MATCHED LINKEDIN', self.matched_linkedins)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getParentCompany(inputValue) {
      return this.$store
        .dispatch("accountsManagement/searchAutocomplete", inputValue)
        .then(response => {
          let data = JSON.parse(JSON.parse(JSON.stringify(response.data)));
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].uuid,
              name: data[property].company_name
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },



    viewAccountDetails(accountId) {
      this.$store
        .dispatch('accountsManagement/fetchAccount', accountId)
        .then(res => {
          this.viewAccountDescription = res.data


          if (this.viewAccountDescription.parent) {
            this.showParentName(this.viewAccountDescription.parent);
          }
          if (this.viewAccountDescription.registration_jurisdiction) {
            this.showRegistrationJurisdiction(
              this.viewAccountDescription.registration_jurisdiction
            );
          }
          if (this.viewAccountDescription.vertical) {
            this.showVertical(this.viewAccountDescription.vertical);
          }



          this.showUpdateSAccountDetailsPopup = true
          this.updateAccountDetailsPopupActive = true





        })
        .catch(err => {
          console.error(err)
        })
    },
    getPotentialMatchesForRequestAccount() {


      let self = this
      self.potential_account_matches = []
      let data = {}
      data.company_name = this.accountDescription.company_name
      data.registered_office_country =
        this.accountDescription.registered_office_country
      data.company_registration_number =
        this.accountDescription.company_registration_number




      if (this.accountDescription.web.length > 0) {
        let all_websites = []
        this.accountDescription.web.forEach(function (ele) {
          all_websites.push(ele.url)
          return ele;
        });
        data.website = all_websites
      }

      if (this.accountDescription.linkedin.length > 0) {
        let all_linkedins = []
        this.accountDescription.linkedin.forEach(function (ele) {
          all_linkedins.push(ele.url)
          return ele;
        });
        data.linkedin = all_linkedins
      }



      this.$store
        .dispatch('accountsManagement/getPotentialMatchesForRequestAccount', data)
        .then(res => {
          self.potential_account_matches = res.data
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getPotentialContactMatchesForDataBuild() {
      let self = this
      let data = {}



      data.company_name = this.contactDescription.company_name
      data.forename = this.contactDescription.forename
      data.surname = this.contactDescription.surname
      data.job_title = this.contactDescription.job_title
      data.email = this.contactDescription.emails
      data.social_media = this.contactDescription.social_medias

      console.log("this.contactDescription", this.contactDescription)

      this.$store
        .dispatch('contactsManagement/getPotentialMatchesForDataBuild', data)
        .then(res => {
          self.potential_contact_matches = []

          self.potential_contact_matches = res.data



        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getExistingCampaignContactMatches() {
      let self = this
      self.existing_campaign_contact_matches = []
      let data = {}
      data.campaign_id = this.campaignId
      data.account_id = this.contactDescription.account_id

      console.log('ACCC', this.contactDescription)

      this.$store
        .dispatch('contactsManagement/getExistingCampaignContactMatches', data)
        .then(res => {
          self.existing_campaign_contact_matches = res.data

          self.existing_campaign_contact_matches.forEach((contact) => {
            self.existed_contact_ids.push(contact.contact_id)
          })

        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getExistingMasterDatabaseContactsMatches() {
      let self = this
      self.existing_master_database_contacts = []
      let data = {}
      data.campaign_id = this.campaignId
      data.account_id = this.contactDescription.account_id

      console.log('ACCC', this.contactDescription)

      this.$store
        .dispatch('contactsManagement/getExistingMasterDatabaseContactsMatches', data)
        .then(res => {
          self.existing_master_database_contacts = res.data

        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getMatchedEmails(email) {
      let self = this

      if (email != null && email != '') {
        email = email.trim()
      }

      self.matched_emails = []
      let data = {}
      data.email = email

      this.$store
        .dispatch('contactsManagement/getMatchedEmails', data)
        .then(res => {
          if (res.data.length != 0) {
            self.matched_emails = res.data
            self.MatchedEmailPopupActive = true
          } else {
            self.AddEmailAnyWay(data.email)
          }

        })
        .catch(err => {
          console.log(err)
        })
    },
    getMatchedSocialMedias(social_media, summary) {
      let self = this

      if (social_media != null && social_media != '') {
        social_media = social_media.trim()
      }

      self.matched_social_medias = []
      let data = {}
      data.social_media = social_media

      this.$store
        .dispatch('contactsManagement/getMatchedSocialMedias', data)
        .then(res => {
          if (res.data.length != 0) {
            self.matched_social_medias = res.data
            self.MatchedSocialMediaPopupActive = true
          } else {
            self.AddSocialMediaAnyWay(data.social_media, summary)
          }

        })
        .catch(err => {
          console.log(err)
        })
    },
    getCurrencyCodes(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCurrencyCodes")
        .then(response => {
          let response_data = response.data
          let mappedArray = [];
          for (const property in response_data) {
            mappedArray.push({
              id: response_data[property].id,
              label: response_data[property].symbol + ' ' + response_data[property].name + ' ' + response_data[property].code
            });
          }
          this.currencyCodes = mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },



    accept() {
      this.popupActive = false
    },
    reject() {
      // this.popupActive = false;
      // this.$router.push({ path: "/dashboard" });
      this.$router.go(0)
    }
  },
  created() {
    var self = this
    defineAbilitiesFor().then(function (data) {
      self.abilities = data
    })
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.user_id = userInfo['uid']


    this.user_role_id = userInfo['roleId']


    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        'campaignsManagement',
        moduleCampaignsManagement
      )
      moduleCampaignsManagement.isRegistered = true
    }

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule('accountsManagement', moduleAccountsManagement)
      moduleAccountsManagement.isRegistered = true
    }

    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule('contactsManagement', moduleContactsManagement)
      moduleContactsManagement.isRegistered = true
    }

    if (!moduleSDSubStatusManagement.isRegistered) {
      this.$store.registerModule("SDSubStatusManagement", moduleSDSubStatusManagement);
      moduleSDSubStatusManagement.isRegistered = true;
    }

    this.campaignId = this.$route.params.campaignId

    this.getPhoneTypes();
    this.getCurrencyCodes();
  }
}
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.searchbox2 {
  padding-left: 40px;
  width: 500px;
  float: right;
  margin-top: 10px;
  margin-bottom: 50px;
}

.satellite_office_field {
  margin-right: 453px;
}

.relative {
  /* position: fixed !important; */
  z-index: 999;
  /* width: 98.5%; */
}

.vxtable {
  /* position: absolute !important; */
  margin-top: 20px;
}

.correction_field_class {
  color: red;
}

.correction_field_input_class {
  border: 1px solid red;
}

.vs-input-class {
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.2);
  font-size: 1rem;
  height: 38px;
  padding-left: 10px;
  padding-right: -10px;
  border-radius: 4px;
  background: transparent;
  transition: all 0.2s ease;
}


.scroll-container {
  max-height: 400px;
  /* Set a maximum height to enable scrolling */
  overflow-y: auto;
  /* Adds a vertical scrollbar if content exceeds max-height */
  /* Hide horizontal scrollbar if necessary */
  overflow-x: hidden;
  border: 1px solid #ccc;
  padding: 10px;
}


.build-complete {
  background-color: rgb(107, 42, 42) !important;
  padding: 0.75rem 2rem;
  border: 1px solid rgb(94, 70, 70);
  color: #fff !important;
  border-radius: 4px;
  cursor: pointer;

  font-size: 18px;

}
</style>